'use strict';
var hasFired = false;
// DEV-12392: the recalc placeholder is the canon skeleton line (m3/_totals.scss);
// clear_order_form_tax_calc (orders.js) recognizes it alongside the old text.
var AM_TOTALS_SKELETON = '<span class="am-skeleton am-skeleton--line"></span>';

function show_order_loading_button(is_loading = false) {
    const $submit_button = am.$('#modal_submit2');

    if (!$submit_button.length) return;

    if (!$submit_button.attr('data-original-text')) {
        $submit_button.attr('data-original-text', $submit_button.text().trim());
    }
    if (!$submit_button.attr('data-original-icon')) {
        const $icon = $submit_button.find('i');
        $submit_button.attr('data-original-icon', $icon.length ? $icon.attr('class') : 'fa fa-save');
    }

    const text = $submit_button.attr('data-original-text');
    const icon = $submit_button.attr('data-original-icon');
    let content = `<span class="moxbutton-icon"><i class="${icon}"></i></span> ${text}`;

    if (is_loading) {
        content = `<span class="moxbutton-icon"><i class="fa fa-spinner fa-spin"></i></span> Processing...`;
    }

    $submit_button
        .prop('disabled', is_loading)
        .find('span').html(content);
}

var Order2 = Class.create({
    CALCULATED_SECTION_ID: 'dev_calculated_adjustments',item_rep: {
        'supply': [/^.*\[([^\[]+)\]$/, 'psupplies[0][$1]'],
        'product': [/pcomponents\[[0-9\-\_]+\]\[products\]/, 'products'],
        'component': ['~', '~']
    },
    initialize: function initialize(opts) {
        this.bind_price_adjustments_debugger();
        try{
            opts = opts || {};
            this.requester = null;
            if (!GUI.templates) GUI.templates = {};
            $('products_section').select('.item_table tbody').each(function (tb) {
                var id = tb.id;
                if (id && tb.down('.p_template')) {
                    if (tb.down().childElements().length == 3) return;
                    GUI.templates[id] = tb.innerHTML;
                    //var pre = tb.previous();
                    tb.remove();
                    //pre.id = id;
                }
            });
            $('products_section').select('select').each(function (sel) {
                get_product_image(sel, sel.up('.product') ? sel.up('.product').getAttribute('data-base') : null);
            });
            if (initLightbox.myLightbox) initLightbox.myLightbox.initialize_more('products_section');
            $$('#productset .item_table tbody').each(function (group) {
                Sortable.create(group, { 'tag': 'tr', onChange: save_pao_headers });
            });
            if ($$('.shipping_method').length) show_hide_shipping();

            this.items_valid = opts.valid_prices || false;
            if (!this.items_valid) {
                $$('.valid').invoke('removeClassName', 'valid').invoke('addClassName', 'stale');
            }
            this.subtotal_valid = opts.valid_prices || false;
            this.shipping_valid = opts.valid_prices || false;
            this.tax_rate_valid = opts.valid_prices || false;
            this.tax_valid = opts.valid_prices || false;
            this.total_valid = false;
            this.otherCostsDataLoaded = false;
            this._warn_on_change = opts.warn_on_change || false;
            if ($('products_section')) {
                $('products_section').delegate('.qty', 'change', this.item_change_handler.bind(this));
                $('products_section').delegate('.price_override', 'change', this.item_change_handler.bind(this));
                $('products_section').delegate('.fa-trash', 'click', this.delete_handler.bind(this));
                $('products_section').delegate('.item_table .fa-copy', 'click', this.copy_handler.bind(this));
                $('products_section').delegate('.attr', 'change', this.item_change_handler.bind(this));
            }
            if ($("jobs")) {
                $("jobs").delegate(".is_taxable_cost","change",this.item_change_handler.bind(this));
                $("jobs").delegate(".costs","change",this.item_change_handler.bind(this));
            }
            $('billing_city','billing_state', 'existing_billing', 'billing_zip', 'shipping_city',"shipping_state",'shipping_state','shipping_zip',
                "shipping_country","shipping_address1",'shipping_country','shipping_address1','shipping_same_as_billing', 'shipping_method').each(function (st) {
                if (st) st.observe('change', this.tax_rate_change_handler.bind(this));
            }.bind(this));
            if ($('disc_percent')) {
                $('disc_percent').observe('change',this.discount_change_handler.bind(this));
                $('disc_percent').observe('input',this.discount_input_handler.bind(this));
            }
            if ($('status')) {
                $('status').observe('change',this.status_change_handler.bind(this));
                if($('status') != 'bid'){
                    this.items_valid = false;
                }
            }
            this._taxHints = {};
            var _self = this;
            ['gt_taxes', 'gt_gst_taxes', 'gt_pst_taxes'].forEach(function(id) {
                var el = document.getElementById(id);
                if (el) {
                    var hint = el.querySelector('.hint--top');
                    if (hint) {
                        _self._taxHints[id] = hint.getAttribute('data-hint');
                    }
                }
            });
            if (!opts.delayProcessing)
                this.process(true);

            this.save_presets();
            //To select text on price override fields.
            am.$(document.body).on('focus', 'input[type="text"][name*="price_override"]', function (e) {
                e.target.select();
            });
        }
        catch(err) {
            console.log(err);
        }
    },
    bind_price_adjustments_debugger: function bind_price_adjustments_debugger() {
        try {
            if (window._price_debugger_bound || !is_dev_mode()) {
                return;
            }
            window._price_debugger_bound = true;
            const _this = this;

            am.$(document).on('click', '.pao_bottom.p_subtotal', function () {
                const subtotal = this;
                try {
                    const $subtotal = am.$(subtotal);
                    const saved_adjustments = $subtotal.data('saved-adjustments');
                    const saved_price = $subtotal.data('saved-price');
                    const instance = subtotal.closest('.product')?.dataset.rsource;
                    const isB2b = !!instance && instance !== 'LOCAL';
                    const savedTitle = isB2b
                      ? 'Saved (stored in the DB at ' + instance + ' &mdash; supplier-side adjustments only)'
                      : 'Saved (Stored in the DB)';

                    if (isB2b && saved_adjustments && Array.isArray(saved_adjustments.detail)) {
                        const base = (subtotal.closest('[data-base]')?.dataset.base || '').replace(/\/+$/, '');
                        saved_adjustments.detail.forEach(function (detail) {
                            detail.instance = instance;
                            if (base) detail.url = base;
                        });
                    }

                    let output = _this.wrap_adjustment_section(
                      'Calculated (recalculated now)',
                      `<div id="${_this.CALCULATED_SECTION_ID}"><p>Recalculating&hellip;</p></div>`,
                      true
                    );

                    if (saved_adjustments) {
                        output += _this.wrap_adjustment_section(
                          savedTitle,
                          _this.format_adjustment_info(saved_price + '', saved_adjustments),
                          false
                        );
                    } else {
                        output += _this.wrap_adjustment_section(
                          savedTitle,
                          '<p>This row has no stored adjustment data.&nbsp; Either it has not been saved to the order ' +
                          'yet, or' + (isB2b
                            ? ' the supplier instance rendered it without the debug attributes.'
                            : ' it is not a regular order product item.') + '</p>',
                          false
                        );
                    }

                    open_modal(output, {
                        title: 'Price Adjustments',
                        afterLoad: function () {
                            _this.render_calculated_adjustments(subtotal);
                        }
                    });
                } catch (e) {
                    console.error(e);
                    open_modal('<p class="error">The price adjustment inspector failed:&nbsp; ' +
                      ((e && e.message) ? e.message : e) + '</p>', {title: 'Price Adjustments'});
                }
            });
        } catch (e) {
            console.error(e);
        }
    },
    render_calculated_adjustments: function render_calculated_adjustments(subtotal) {
        const _this = this;
        const write = function (html) {
            const target = document.getElementById(_this.CALCULATED_SECTION_ID);
            if (target) target.innerHTML = html;
        };

        return this.fetch_debug_pricing(subtotal)
          .then(function (data) {
              if (data && data.hasOwnProperty('adjustments')) {
                  write(_this.format_adjustment_info(data.price, data.adjustments));
              } else {
                  write('<p>The pricing response for this row carried no <code>adjustments</code> data.&nbsp; ' +
                    'On B2B/remote rows this means the supplier instance returned no adjustment breakdown.</p>');
              }
          })
          .catch(function (e) {
              console.error(e);
              write('<p class="error">Could not recalculate this row:&nbsp; ' +
                ((e && e.message) ? e.message : e) + '</p>');
          });
    },
    fetch_debug_pricing: function fetch_debug_pricing(subtotal) {
        const _this = this;
        const product = subtotal ? $(subtotal.closest('.product')) : null;
        if (!product) {
            return Promise.reject(new Error('The clicked subtotal is not inside a product row.'));
        }

        const type = product.hasClassName('supply') ? 'supply' : 'product';
        const rtype = product.getAttribute('data-rtype');
        const params = {};

        product.select('select, input, textarea').each(function (ele) {
            let name = ele.getAttribute('name');
            if (!name) return;
            if (_this.item_rep[type]) name = name.replace(_this.item_rep[type][0], _this.item_rep[type][1]);
            params[name] = $F(ele);
        });

        Object.keys(params).forEach(function (key) {
            if (key.indexOf('[is_dirty]') !== -1) params[key] = true;
        });

        if ($('company_id')) params['company_id'] = $F('company_id');
        if ($('disc_percent')) {
            params['discount_percent'] = $('disc_percent').value
              ? $F('disc_percent')
              : parseFloat($('disc_percent').innerHTML);
        }
        if ($('discount_onload')) params['discount_onload'] = $F('discount_onload');

        let request_uri;
        if (rtype) {
            request_uri = 'ajax/orders/get_rcatalog_pricing/';
            params['rtype'] = rtype;
            params['rid'] = product.getAttribute('data-rid');
            params['rsource'] = product.getAttribute('data-rsource');
            params['rnum'] = product.getAttribute('data-rnum');
            if (product.up('.component')) params['is_component'] = 1;
        } else if ($('c_form')) {
            request_uri = 'ajax/components/get_' + type + '_pricing/';
        } else {
            request_uri = 'ajax/orders/get_' + type + '_pricing/';
        }

        let cstatus;
        try {
            cstatus = product.down('.current_status').value.length === 0
              ? ORDER_STATUS_BID
              : document.getElementById('status').value;
        } catch (err) {
            cstatus = ORDER_STATUS_BID;
        }

        params['discountDirty'] = false;
        params['is_remake'] = ($('is_remake') && $('is_remake').value) || 0;
        params['cstatus'] = cstatus;
        params['debug'] = true;

        const cacheKey = request_uri + '|' + JSON.stringify(Object.keys(params).sort().map(function (key) {
            return [key, params[key]];
        }));
        if (!this._debug_pricing_cache) this._debug_pricing_cache = new Map();
        if (this._debug_pricing_cache.has(cacheKey)) {
            return this._debug_pricing_cache.get(cacheKey);
        }

        const request = new Promise(function (resolve, reject) {
            new Ajax.Request(request_uri, {
                parameters: params,
                onSuccess: function (ret) {
                    const ob = ret.responseJSON;
                    if (!ob) {
                        return reject(new Error(ret.responseText || 'The pricing endpoint returned no data.'));
                    }
                    const rows = product.select('.item_table tbody tr').filter(function (tr) {
                        return Number(tr.querySelector('.qty').value);
                    });
                    const index = rows.indexOf($(subtotal).up('tr'));
                    resolve(ob.length > 0 ? (ob[index > -1 ? index : 0] || ob[0]) : ob);
                },
                onFailure: function (ret) {
                    reject(new Error('Request failed with status ' + ret.status + '.'));
                },
                onException: function (request, exception) {
                    reject(exception);
                }
            });
        });

        this._debug_pricing_cache.set(cacheKey, request);
        request.catch(function () { _this._debug_pricing_cache.delete(cacheKey); });

        return request;
    },
    wrap_adjustment_section: function wrap_adjustment_section(title, body, open) {
        return `<details ${open ? 'open' : ''}>
                    <summary class="cursor-pointer">${title}</summary>
                    <div style="padding: 1rem;">${body}</div>
                </details>`;
    },
    format_adjustment_info: function (price, adj) {
        if (!adj || typeof adj !== 'object') {
            return '<p>No adjustment data available' + (adj ? ': <pre>' + adj + '</pre>' : '.') + '</p>';
        }
        const num = (value) => (isNaN(parseFloat(value)) ? 0 : parseFloat(value));
        const visible_amount = num(adj.visible_amount);

        let output = '<strong>Base price</strong>: $' + this.formatNumber(num(adj.base_price)) + '<br>';
        output += '<strong class="extended-line-height">Adjustments (Visible)</strong>: $' + this.formatNumber(num(adj.visible_adjustments)) + '<br>';
        output += '<strong class="extended-line-height">Order Discount</strong>: $' + this.formatNumber(num(adj.order_discount)) + '<br>';
        output += '<strong class="extended-line-height">Total adjustment(visible + non-visible + order discount)</strong>' +
          ': $' + this.formatNumber(visible_amount) + '<br>';

        if (visible_amount != 0) {
            output += '<b>Result:</b>' + this.format_discount_output(visible_amount, price);
        } else {
            output += '<b>Result:</b>' + CurrencyFormatted(price);
        }

        if (Array.isArray(adj.detail) && adj.detail.length) {
            output += '<hr><p>Adjustments:</p>' + this.get_adjustments_detail_table(adj);
        } else {
            output += '<hr><p>No adjustments found!</p>';
        }

        return output;
    },
    get_adjustments_detail_table: function (adj) {
        const {is_admin: userIsAdmin} = get_user_info();

        let outputHtml = '<table class="am-table-fixed w-100">';
        outputHtml +=
            `<tr>
                <th class="fw-medium text-center">Id</th>
                <th class="fw-medium text-center">Instance</th>
                <th class="fw-medium text-center">Name</th>
                <th class="fw-medium text-center">Show on orders</th>
                <th class="fw-medium text-center">Discount/Surcharge</th>
            </tr>`;

        for (const data of adj.detail) {
            if ('instance' in data && !userIsAdmin) {
                // hide remote adjustments on non-admin user's
                continue;
            }

          // A remote id is meaningless against the local settings page, so it is only
          // linked when the payload says which instance it belongs to.
          let idCell = `#${data.discount_id}`;
          if ("url" in data) {
            idCell = `<a href="${data.url}/settings/adjustments/edit/${data.discount_id}" target="_blank">${idCell}</a>`;
          } else if (!("instance" in data)) {
            idCell = `<a href="settings/adjustments/edit/${data.discount_id}" target="_blank">${idCell}</a>`;
          }

            outputHtml += '<tr>';
            outputHtml += `<td>${idCell}</td>`;
            outputHtml += `<td>${data.instance || 'LOCAL'}</td>`;
            outputHtml += `<td>${data.name || '-'}</td>`;
            outputHtml += `<td class="text-center">${data.show_on_orders ? 'Yes' : 'No'}</td>`;
            outputHtml += `<td class="text-end">${this.formatNumber(data.discount_amount)}</td>`;
            outputHtml += '</tr>';
        }
        outputHtml += '</table>';

        return outputHtml;
    },
    save_presets: function () {
        am.$('#presets .preset').each(function (_, el) {
            const $element = am.$(el);
            let value = $element.val();

            if ($element.is(':checkbox')) {
                value = $element.is(':checked') ? value : '';
            }

            $element.attr('data-old-value', value);
        });
    },
    discount_input_handler: function (ev) {
        $('jobs').addClassName('discountDirty');
        $('disc_percent').addClassName('isDirty');
        var D = $$('.is_dirty');
        var DD = $$('.discount_is_dirty');
        var CD = $$('.current_discount');

        for (var i = 0; i < D.length; i++) {
            var prodItemName1 = D[i].name;
            document.getElementsByName(prodItemName1)[0].value = true;
        }
        for (var i = 0; i < DD.length; i++) {
            var prodItemName2 = DD[i].name;
            document.getElementsByName(prodItemName2)[0].value = true;
        }
        for (var i = 0; i < CD.length; i++) {
            var currentDiscount = CD[i].name;
            document.getElementsByName(currentDiscount)[0].value = cur2num($('disc_percent').value);
        }
    },
    discount_change_handler: function discount_change_handler(ev) {
        loadingControl();
        this.discount_input_handler(ev);

        var el = ev.element();
        el.value=number_format(cur2num(el.value),3);
        $$('.valid').invoke('removeClassName', 'valid').invoke('addClassName', 'stale');
        // DEV-12392: the pricing leg can grind for many seconds before the tax/total
        // legs write anything, leaving pre-edit amounts on screen with no sign a
        // recalc is running — swap every visible money slot to the canon skeleton
        // line up front (clear_order_form_tax_calc already recognizes it).
        ['products_total', 'gt_taxes', 'gt_gst_taxes', 'gt_pst_taxes', 'final_price'].forEach(function (id) {
            var slot = document.getElementById(id);
            if (slot && slot.offsetParent !== null) slot.innerHTML = AM_TOTALS_SKELETON;
        });
        am_skeleton_takeover();
        this.invalidate('items').invalidate('total').invalidate('tax').invalidate('tax_rate').process();

        $('jobs').removeClassName('discountDirty');
    },
    status_change_handler: function status_change_handler(ev) {
        var D = $$('.current_status');
        for (var i = 0; i < D.length; i++) {
            var statusName = D[i].name;
            if($('status') && $('status').value && document.getElementsByName(statusName) && document.getElementsByName(statusName)[0])
                document.getElementsByName(statusName)[0].value = $('status').value;
        }
    },

    item_change_handler: function item_change_handler(ev) {
        var jobs = document.getElementById('jobs');
        var el = ev.element();
        var product = el.up(".product");

    if (el.classList.contains("attr")) {
      const { attrType } = el.dataset; // data-attr-type
      if (attrType === "text" || attrType === "paragraph") {
        return;
      }

      if (attrType === "select") {
        const reloaded = reloadSelectOptionTags(el);
        if (!reloaded) {
          console.info('Select is dirty and options need to be reloaded.');
        }
      }
    }

        if (jobs) {
            var hasPayment = jobs.getAttribute("data-payment") === "true";
            var hasCheckedStatus = jobs.getAttribute("data-check_status") === "true";
            var isEmployee = jobs.getAttribute("data-employee") === "true";
        }
        if (jobs && isEmployee && !hasFired && hasPayment) {
            let isExecuted = confirm(get_language_translation('LANG_MSG__A_PAYMENT_HAS_BEEN_MADE_ON_THIS_ORDER_EDITING_THE_ORDER_WILL_NOW_LIKELY_RESULT_IN_ISSUES_WITH_THE_INVOICE_TOTAL') + '.')
            if(isExecuted){
                hasFired = true;
                el.up('.product').removeClassName('valid').addClassName('stale');
                if (product) product.removeClassName("valid").addClassName("stale");
                this.invalidate('items').process();
                if($('b2b_reseller_agree'))
                    $('b2b_reseller_agree').value = 0;
                alert(get_language_translation('LANG_MSG_YOUR_CHANGES_WILL_NOW_BE_REFLECTED_ON_THE_CURRENT_ORDER'))
            } else if(!isExecuted){
                alert(get_language_translation('LANG_MSG_THE_PREVIOUS_ORDER_SELECTIONS_WILL_BE_RESTORED'))
                //reset to loaded value
                el.value = el.getAttribute('data-loadedval');
                    if (el.tagName == 'SELECT') get_product_image(el, product ? product.getAttribute("data-base") : null);
            }
        }
        const isProjectOrder =
            this.isTypeProject && typeof this.isTypeProject === "function"
                ? this.isTypeProject()
                : false;
        const verifiedWarningKey = isProjectOrder
            ? "LANG_MSG_THIS_ORDER_IS_CONFIRMED_CHANGING_ATTRS_WILL_CAUSE_PRICES_TO_RECALCULATE_ARE_YOU_SURE"
            : "LANG_MSG_THIS_ORDER_IS_VERIFIED_CHANGING_ATTRS_WILL_CAUSE_PRICES_TO_RECALCULATE_ARE_YOU_SURE";

        if (!this._warn_on_change || confirm(get_language_translation(verifiedWarningKey))) {
            this._warn_on_change = false;
            if (product) product.removeClassName("valid").addClassName("stale");
            this.invalidate('items').invalidate('total').invalidate('tax').invalidate('tax_rate').process();
            if($('b2b_reseller_agree'))
                $('b2b_reseller_agree').value = 0;
        } else {
            //reset to loaded value
            el.value = el.getAttribute('data-loadedval');
            if (el.tagName == 'SELECT') get_product_image(el, product ? product.getAttribute("data-base") : null);
        }
        this.toggle_order_controls();
    },
    copy_handler: function copy_handler(ev) {
        var el = ev.element();
        GUI.copy(el, undefined, undefined, ($new_element) => {
            $new_element.find('[data-litebox_initialized]').removeAttr('data-litebox_initialized');
            $new_element.addClass('stale');
        });
        var prod_el = el.up('.product');
        if (prod_el.down('.gtotal')) {
            var prod_total = 0, item_count = 0;
            prod_el.select('.p_subtotal').collect(function(a) {
                if (a.innerHTML != '-') {
                    item_count += parseInt(a.up('tr').down('.qty').value);
                    prod_total += cur2num(a.innerHTML);
                }
            });
            prod_el.down('.gitotal').update(item_count);
            prod_el.down('.gtotal').update(CurrencyFormatted(prod_total.toFixed(2)));

        }
        if (initLightbox.myLightbox) {
            initLightbox.myLightbox.initialize_more('products_section');
        }
        this.invalidate('items').invalidate('total').invalidate('tax').invalidate('tax_rate').process();
        this.update_folders_subtotal();
        this.toggle_order_controls();
    },
    delete_handler: function delete_handler(ev) {
        /**@var {HTMLElement} $product*/
        var el = ev.element();
        const $product = el.closest('.product');
        if (el.up('.line_items')) {
            var prod_el = el.up('.product');
            el.up("tr").remove();
            if (prod_el.down('.gtotal')) {
                var prod_total = 0, item_count = 0;
                prod_el.select('.p_subtotal').collect(function(a) {
                    if (a.innerHTML != '-') {
                        item_count += parseInt(a.up('tr').down('.qty').value);
                        prod_total += cur2num(a.innerHTML);
                    }
                });
                prod_el.down('.gitotal').update(item_count);
                prod_el.down('.gtotal').update(CurrencyFormatted(prod_total.toFixed(2)));

            }

        } else {
            if (!confirm(get_language_translation('LANG_ARE_YOU_SURE_YOU_WISH_TO_DELETE_THIS_PRODUCT'))) return false;
            if ($(el).up('#cart_queue')) {
                var instance = el.up('#cart_queue').down('.product').getAttribute('data-rsource');
                empty_cart_queue(true);
            }
            else {
                var instance = el.up('.product').getAttribute('data-rsource');
                $(el).up(".product").remove();
            }
            remove_shipping_group(instance);
            if ($('cart_content') && !$('cart_content').select('.product').length) {
                $('cart_empty').show();
            }
        }
        $product?.querySelectorAll('.is_dirty').forEach(e => {
            e.value = true;
        });
        GUI.loss_prevention.form_changed();
        this.invalidate('items')
            .invalidate('subtotal')
            .invalidate('shipping')
            .process();
        this.toggle_order_controls();
    },
    tax_rate_change_handler: function tax_rate_change_handler(ev) {
        this.invalidate('shipping').invalidate('tax_rate').process();
    },
    invalidateAll: function () {
        document.querySelectorAll('.valid').forEach(e => {
            e.classList.remove('valid');
            e.classList.add('stale');
        });

        return this
            .invalidate('items')
            .invalidate('shipping')
            .invalidate('tax_rate')
            .invalidate('tax')
            .invalidate('subtotal')
            .invalidate('total');
    },
    invalidate: function invalidate(section) {
        if (typeof this[section + '_valid'] === 'boolean') this[section + '_valid'] = false;
        //if(section === 'items')
        //  this.subtotal_valid = false;
        return this;
    },
    show_loading_button: function (is_loading = false) {
        show_order_loading_button(is_loading);
    },
    handle_b2b_errors: function (original_request) {
        const r = original_request.requester;
        if (r?.url === 'ajax/orders/get_rcatalog_pricing/') {
            const productKey = Object.keys(r.parameters || {}).find(key => key.startsWith('products['));
            if (productKey) {
                const match = productKey.match(/\[(.*?)\]/);
                const productNumber = match ? match[1] : null;

                if (productNumber) {
                    // Add error notice to the target div
                    const targetDiv = document.querySelector(`[id^="product_${productNumber}"]`);
                    targetDiv?.insertAdjacentHTML(
                        'beforeend',
                        `<div class="d-block error mb-0 b2b-error-notice">
                             ${get_language_translation('LANG_CANT_PULL_REMOTE_INFO')}
                            <br />
                        </div>`
                    );

                    // Add error styling to the price element
                    const targetPrice = document.querySelector(`[id^="p_price_${productNumber}"]`);
                    if (targetPrice) {
                        targetPrice.classList.add('error', 'p-0');
                    }
                }
            }
        }
    },
    clean_b2b_errors: function () {
        // Remove all error notices
        document.querySelectorAll('.b2b-error-notice').forEach(element => {
            element.remove();
        });
        // Remove error styling from price elements
        document.querySelectorAll('[id^="p_price_"]').forEach(element => {
            element.classList.remove('error', 'p-0');
        });
    },
    process: function process(initialLoad) {
        var isInitialLoad = !!initialLoad;
        this._isInitialLoad = isInitialLoad;

        // Per-run record: a superseded run is marked aborted so its rejection is
        // swallowed and its RUM timing event is never reported (DEV-12921).
        const thisRun = {aborted: false, t0: window.am_rum_now ? am_rum_now() : Date.now()};
        if (this.requester && callInProgress(this.requester.transport)){
          console.log("Aborting previous request...");
          if (this._currentRun) this._currentRun.aborted = true;
          this.requester.transport.abort();
        }
        this._currentRun = thisRun;
        var original_request = this;
        this.show_loading_button(true);
        this.clean_b2b_errors();
        return this.calculate_items()
        .then(this.calculate_component_totals.bind(this))
        .then(this.calculate_subtotal.bind(this))
        .then(this.calculate_quote_data.bind(this))
        .then(this.calculate_margin.bind(this))
        .then(function () { return original_request.get_tax_rate(isInitialLoad); })
        .then(this.calculate_shipping.bind(this))
        .then(this.calculate_tax.bind(this))
        .then(this.calculate_total.bind(this))
            .then(() => {
                this.show_loading_button(false);
                this.rum_pricing_event(thisRun, isInitialLoad, false);
            })
        .catch((e) => {
            this.rum_pricing_event(thisRun, isInitialLoad, true);
            if (thisRun.aborted) return;
            this.handle_b2b_errors(original_request);
            this.show_loading_button(false);
            console.log('%c Error Processing', 'background-color: red; color: yellow;');
            console.log(e);
            return false;
        });
    },
    // RUM custom event (DEV-12921): the pricing round-trip is the order form's slow
    // path and its ajax routes are excluded from RUM's http telemetry (expected
    // aborts), so this is the only timing RUM gets for it. Superseded runs are not
    // reported: process() marks them aborted before this is reached.
    rum_pricing_event: function rum_pricing_event(run, isInitialLoad, failed) {
        if (!window.am_rum_event || !run || run.aborted) return;
        am_rum_event('mrp.pricing', {
            ms: Math.round(am_rum_now() - run.t0),
            items: document.querySelectorAll('.p_subtotal, .c_subtotal').length,
            initial_load: !!isInitialLoad,
            failed: !!failed
        });
    },
    process_without_items: function process_without_items()
    {
        if (this.requester && callInProgress(this.requester.transport)) this.requester.transport.abort();
        //this.get_subtotal_price() + this.get_shipping_price() + this.get_quote_price() + this.get_profit_price() + this.get_tax_price()
        this.calculate_items()
        .then.calculate_shipping.bind(this);
    },
    calculate_items: function calculate_items() {
        var _this = this;

        return new Promise(async function (resolve, reject) {
            if (_this.items_valid) {
                return resolve(true);
            }
            if (_this.otherCostsDataLoaded === false && _this.isTypeProject()) {
                _this.otherCostsDataLoaded = null;
                await _this?.getOtherCostsData();
                _this.otherCostsDataLoaded = true;
            }
            _this.calculate_item_counts();
            var items = $('products_section').select(".product.stale:not(.component)");

            Promise.all(items.map(_this.get_item_price.bind(_this))).then(function (prices) {
                this.items_valid = true;
                resolve(true);
            }.bind(_this)).catch(function (err) {
                console.log('%c Items: Failure', 'background-color: red; color: yellow;');
                console.log({err: err});
                reject(false);
                return false;
            });
        });
    },
    calculate_item_counts: function calculate_item_counts() {
        this.qtys = {};
        this.tot_qty = 0;
        if ($('jobs')) {
            const $folders = am.$('.order-folder');
            if ($folders.length > 0) {
                const folder_quantities = {};

                $folders.each((index, element) => {
                    const folder_id = element.id;

                    if (!folder_quantities.hasOwnProperty(folder_id)) {
                        folder_quantities[folder_id] = 0;
                    }

                    const qtys = [
                        get_quantity_by_instance('productset', folder_id),
                        get_quantity_by_instance('supplyset', folder_id),
                        get_quantity_by_instance('componentset', folder_id),
                        get_quantity_by_instance('cart_product'),
                        get_quantity_by_instance('project-line-items-set', folder_id),
                    ];

                    for (let i = 0; i <= qtys.length; i++) {
                        for (const instance in qtys[i]) {
                            if (qtys[i].hasOwnProperty(instance)) {
                                folder_quantities[folder_id] += qtys[i][instance];
                            }
                        }
                    }
                });

                Object.entries(folder_quantities).forEach(([folder_id, quantity]) => {
                    am.$('#' + folder_id + ' .order-folder-qty').text(quantity);
                });
            }

            this.qtys = {};
            var qtys = [get_quantity_by_instance('productset'), get_quantity_by_instance('supplyset'), get_quantity_by_instance('componentset'), get_quantity_by_instance('cart_product')];
            for (var i = 0; i <= 3; i++) {
                for (var instance in qtys[i]) {
                    if (qtys[i].hasOwnProperty(instance)) {
                        if (!this.qtys.hasOwnProperty(instance)) this.qtys[instance] = 0;
                        this.qtys[instance] += qtys[i][instance];
                        this.tot_qty += qtys[i][instance];
                    }
                }
            }
        } else {
            $$('.total_items').each(function (el) {
                const instance = el.getAttribute('data-rsource');
                this.qtys[instance] = Number(el.value);
                this.tot_qty += Number(el.value);
            }.bind(this));
        }
        if ($('total_qty')) {
            $('total_qty').update(this.tot_qty);
        }
        total_order_weight();
    },
    updateDirty: function updateDirty(isDirty, obj, val){
        var tempx = isDirty.replace("[is_dirty]", "[items]");
        var prodItems = obj.querySelectorAll("input[name^='" + tempx + "']");
        for (var i = 0; i < prodItems.length; i++) {
            if(prodItems[i].name.search("is_dirty") > -1){
                var prodItemName = prodItems[i].name;
                document.getElementsByName(prodItemName)[0].value = val;
                break;
            }
        }
    },
    get_item_price: function get_item_price(obj) {
        var _this2 = this;

        return new Promise(function (resolve, reject) {
            var type = obj.hasClassName('supply') ? 'supply' : 'product';
            if (obj.hasClassName('manual')) return resolve(obj); // no ajax if manually overridden
            var id = obj.id || container.identify();
            var rtype = obj.getAttribute('data-rtype');
            var rid = obj.getAttribute('data-rid');
            var rsource = obj.getAttribute('data-rsource');
            if($('jobs') && $('jobs').hasClassName('discountDirty'))
                var discountDirty = $('jobs').hasClassName('discountDirty');
            else if($('c_form'))
                var discountDirty = true;
            else
                var discountDirty = false;

            try {
                if(obj.down('.current_status').value.length == 0){
                    var cstatus = 'bid';
                }
                else{
                    var cstatus = document.getElementById('status').value;
                }
            }
            catch(err) {
                var cstatus = 'bid';
            }

            var in_cart = ($('order_cart') && obj.up('#order_cart')) || !$('order_cart');
            if (obj.down('.group_attrs') && obj.select('.line_items tbody tr').length < 1) { //no rows, don't try to process
                obj.removeClassName('stale').addClassName('valid');
                return resolve(obj);
            }
            var isDirty = obj.down('.is_dirty').getAttribute('name');

            // prepare and validate the request
            var params = {}, success = true;
            var objDirty = false;
            var is_remake = 0;
            try {
                if($('is_remake') && $('is_remake').value)
                    is_remake = $('is_remake').value;
            }
            catch(err) {
                is_remake = 0;
            }

            obj.select('select, input, textarea').each(function (ele) {
                var name = ele.getAttribute('name');
                if (!name) return;

                if($('c_form')){
                    document.getElementsByName(isDirty)[0].value = true;
                    _this2.updateDirty(isDirty, obj, true);
                    objDirty = true;
                    obj.addClassName('isDirty');
                    ele.addClassName('isDirtyElm');
                }
                else if( (ele.tagName == 'TEXTAREA' ||  ele.tagName == 'INPUT') && ele.value != ele.defaultValue){
                    const {attrType} = ele.dataset;
                    if ((attrType !== 'paragraph' && attrType !== 'text') || !attrType) {
                        document.getElementsByName(isDirty)[0].value = true;
                        _this2.updateDirty(isDirty, obj, true);
                        objDirty = true;
                        obj.addClassName('isDirty');
                        ele.addClassName('isDirtyElm');
                    }
                }
                else if(ele.tagName == 'SELECT' && ele.options.length > 0 && !ele.options[ele.selectedIndex].defaultSelected && ele.options[ele.selectedIndex].value.length > 0){
                    document.getElementsByName(isDirty)[0].value = true;
                    _this2.updateDirty(isDirty, obj, true);
                    objDirty = true;
                    obj.addClassName('isDirty');
                    ele.addClassName('isDirtyElm');
                }
                if (ele.tagName == 'SELECT' || ele.tagName == 'INPUT') {
                    var val = $F(ele);
                    if (ele.hasClassName('qty')) {
                        if (val.length && !val.match(/^(\d+)$/)) {
                            ele.addClassName('invalid');
                            alert(get_language_translation('LANG_MSG_THE_QTY_MUST_BE_A_WHOLE_NUMBER'));
                            success = false;
                            return;
                        } else ele.removeClassName('invalid');
                    } else if (ele.hasClassName('pnum')) {
                        var bool = true,
                            mox = ele.up('form').mox,
                            chk;
                        if (!mox) return; // don't bother to analyze if validation is not set up
                        mox.failed = true;

                        //Trim spaces for numerical value for qol update
                        ele.value = ele.value.trim();
                        val = ele.value;

                        if (val.length && (!val.match(/^(\d+)?(\.\d+|\ ?\d+\/\d+)?$/) || val.match(/[^\d\.\ \/]/ || val.indexOf(' ') != val.lastIndexOf(' ') || val.indexOf('/') != val.lastIndexOf('/'))))
                            bool = false;
                        else {
                            if (chk = ele.getAttribute('onvalidate')) {
                                if (chk == '()') chk = 'true';
                                if (val.length) bool = eval(chk.replace(new RegExp('this', 'g'), frac_to_dec(val)));
                            }
                        }
                        if (bool) {
                            ele.removeClassName('invalid');
                        } else {
                            if (ele.style.backgroundColor.blank())
                            {
                                var display_name = ele.getAttribute('data-display_name');
                                alert('The value "' + val + '" is not valid for ' + (display_name ? ('field "' + display_name + '"') : 'that field') + '.');
                            }
                            ele.addClassName('invalid');
                            success = false;
                            return;
                        }
                    } else if (ele.tagName === 'SELECT' && !ele.multiple) {
                        const selectedIndex = ele.selectedIndex;
                        if (selectedIndex >= 0) {
                            const selectedOption = ele.selectedOptions[selectedIndex];
                            if (selectedOption?.disabled) {
                                return;
                            }
                        }
                    }
                }

                if(obj.hasClassName('isDirty')){
                    objDirty = true;
                }
                if (this.item_rep[type]) name = name.replace(this.item_rep[type][0], this.item_rep[type][1]);
                params[name] = $F(ele);
            }.bind(_this2));

            if (!success){
                return reject(obj);
            }
            if ($('company_id'))
                params['company_id'] = $F('company_id');

            if ($('disc_percent')) {
                if ($('disc_percent').value){
                    params['discount_percent'] = $F('disc_percent');
                }
                else if($('disc_percent') && $('disc_percent').innerHTML){
                    params['discount_percent'] = parseFloat($('disc_percent').innerHTML);
                }
            }
            if ($('discount_onload'))
                params['discount_onload'] = $F('discount_onload');


            var request_uri = '';
            if (rtype) {
                request_uri = 'ajax/orders/get_rcatalog_pricing/';
                params['rtype'] = rtype;
                params['rid'] = rid;
                params['rsource'] = rsource;
                params['rnum'] = obj.getAttribute('data-rnum');
                if(obj.up('.component'))
                    params['is_component'] = 1;
            }
            else if($('c_form')){
                request_uri = 'ajax/components/get_' + type + '_pricing/';
            }
            else{
                request_uri = 'ajax/orders/get_' + type + '_pricing/'; // e.g. get_product_pricing, get_component_pricing
            }
            if(discountDirty && cstatus != 'bid' )
                params['discountDirty'] = discountDirty;
            else
                params['discountDirty'] = false;

            if (!$('is_remake')) {
                if ($('products_total') && in_cart) $('products_total').update(AM_TOTALS_SKELETON);
            }
            params['is_remake'] = is_remake;
            params['cstatus'] = cstatus;
            params['debug'] = is_dev_mode();
            const isUngroupedProduct = obj.closest('.product').querySelector('.item_table.line_items') === null;

            if((!objDirty && !discountDirty && cstatus != 'bid') || is_remake == 1){
                window.busy_validating = true;
                _this2.requester = new Ajax.Request(request_uri, {
                    parameters: params,
                    onException: function onException(request, exception) {
                        if (console && console.log) {
                            console.log(['Ajax exception (get_item_price):', exception && exception.message, 'in', exception && exception.fileName, 'line #' + (exception && exception.lineNumber)].join(' '));
                        }
                        window.busy_validating = false;
                        reject(obj);
                    },
                    onSuccess: function (ret) {
                        if (ret.status == 200) {
                            var ob = ret.responseJSON;
                            if (!ob) {
                                return reject(obj);
                            }
                            let list = obj.select('.item_table tbody tr').filter(tr => Number(tr.querySelector('.qty').value));
                            this.clear_grouped_validation_messages(obj);
                            if(ob.length > 0){
                                ob.forEach((data, i) => {
                                    if(ob.length == 1 && isUngroupedProduct){
                                        var xD =  ob[0];
                                        var xC =  obj;
                                    }
                                    else{
                                        var xD =  data;
                                        var xC =  list[i];
                                    }
                                    xD['objDirty'] = objDirty;
                                    xD['discountDirty'] = discountDirty;
                                    xD['cstatus'] = cstatus;
                                    this.handle_price_error(xD, xC);
                                    if(objDirty || discountDirty || this.productIsDirty(xC)){
                                        this.update_product_price(xD, xC, rtype);
                                    }
                                });
                            }
                            else{
                                var xD =  ob;
                                var xC =  obj;
                                xD['objDirty'] = objDirty;
                                xD['discountDirty'] = discountDirty;
                                xD['cstatus'] = cstatus;
                                this.handle_price_error(xD, xC);
                                if(objDirty || discountDirty || this.productIsDirty(xC)){
                                    this.update_product_price(xD, xC, rtype);
                                }
                            }
                            if(objDirty || discountDirty || this.productIsDirty(obj)) {
                                this.handleTaxExemptLabel(ob, obj);
                                this.update_group_subtotals(obj, ob, is_remake);
                            }
                            this.toggle_order_controls();
                            resolve(obj);
                        }
                        else if(ret.status == 0)
                        {
                            reject(obj);
                        }
                        window.busy_validating = false;
                    }.bind(_this2),
                    onFailure: function onFailure(ret) {
                        reject(obj);
                        window.busy_validating = false;
                    }
                });
                return resolve(obj);
            }

            if($('c_form') || objDirty){
                for (var p in params){
                    if(p.indexOf("[is_dirty]") != -1)
                        params[p] = true;
                }
            }
            window.busy_validating = true;
            _this2.requester = new Ajax.Request(request_uri, {
                parameters: params,
                onException: function onException(request, exception) {
                    if (console && console.log) {
                        console.log(['Ajax exception (get_item_price):', exception && exception.message, 'in', exception && exception.fileName, 'line #' + (exception && exception.lineNumber)].join(' '));
                    }
                    window.busy_validating = false;
                    reject(obj);
                },
                onSuccess: function (ret) {
                    if (ret.status == 200) {
                        var ob = ret.responseJSON;
                        if (!ob) {
                            var str = ret.responseText || "Pricing error -- check the pricing formula for this product.";
                            obj.down('.error_container').update(str).show();
                            return reject(obj);
                        }
						if(cstatus && cstatus == 'bid'){
							objDirty = true;
						}
                        let list = obj.select('.item_table tbody tr').filter(tr => Number(tr.querySelector('.qty').value));
                        this.clear_grouped_validation_messages(obj);
                        if(ob.length > 0){
                            ob.forEach((data, i) => {
                                if(ob.length == 1 && isUngroupedProduct){
                                    var xD =  ob[0];
                                    var xC =  obj;
                                }
                                else{
                                    var xD =  data;
                                    var xC =  list[i];
                                }

                                xD['objDirty'] = objDirty;
                                xD['discountDirty'] = discountDirty;
                                xD['cstatus'] = cstatus;
                                this.handle_price_error(xD, xC);

                                this.update_product_price(xD, xC, rtype);
                            });
                        }
                        else{
                            var xD =  ob;
                            var xC =  obj;
                            xD['objDirty'] = objDirty;
                            xD['discountDirty'] = discountDirty;
                            xD['cstatus'] = cstatus;
                            this.handle_price_error(xD,  xC);
                            this.update_product_price(xD, xC, rtype);
                        }

                        this.handleTaxExemptLabel(ob, obj);
                        this.update_group_subtotals(obj,ob, is_remake);

                        var component = obj.up('.component');
                        if (component) {
                            var sum = 0;
                            var reg_sum = 0;
                            var raw_sum = 0;
                            component.select('.p_subtotal').each(function (a) {
                                sum += cur2num(a.innerHTML);
                                reg_sum += parseFloat(a.getAttribute('data-reg_subtotal'));
                                raw_sum += parseFloat(a.getAttribute('data-raw-subtotal'));
                            });
                            if (!sum) {
                                component.down('.price').update('-');
                                component.down('.c_subtotal').update('-');
                                component.down('.c_subtotal').setAttribute('data-raw-subtotal', 0)
                                component.down('.c_subtotal').setAttribute('data-reg_subtotal', 0);
                            } else {
                                sum = sum.toFixed(2);
                                if (sum[0] == 0) sum = sum.slice(1);
                                component.down('.price').update(CurrencyFormatted(sum));
                                var qty = component.down('.qty').value - 0;
                                component.down('.c_subtotal').update(qty ? CurrencyFormatted((sum * qty).toFixed(2)) : '-');
                                component.down('.c_subtotal').setAttribute('data-reg_subtotal', reg_sum * qty);
                                component.down('.c_subtotal').setAttribute('data-raw-subtotal', raw_sum * qty);
                            }
                        }
                        obj.removeClassName('stale').addClassName('valid');
                        this.toggle_order_controls();
                        // if (in_cart) this.invalidate('subtotal').invalidate('shipping').invalidate('tax');
                        resolve(obj);
                    }
                    else if(ret.status == 0)
                    {
                        reject(obj);
                    }
                    window.busy_validating = false;
                }.bind(_this2),
                onFailure: function onFailure(ret) {
                    reject(obj);
                    window.busy_validating = false;
                }
            });

        });
    },
    productsAreDirty: function () {
        let productsAreDirty = false;
        document.querySelectorAll('.is_dirty').forEach((e) => {
            if (e.value === 'true') {
                productsAreDirty = true;
            }
        });
        return productsAreDirty;
    },
    toggle_order_controls: function () {
        /** @type HTMLSelectElement {$orderStatus} */
        const $orderStatus = document.querySelector('#status');
        const orderStatus = $orderStatus?.value;
        const ALLOW_SAVE_BIDS_WITH_ERRORS = document.querySelector('#allow_save_bids_with_errors')?.value.toString() === '1';
        let productWithValidationErrorCount = document.querySelectorAll('.fail').length;
        const orderHasValidationErrors = productWithValidationErrorCount > 0;
        const productsAreDirty = this.productsAreDirty();

        if (orderStatus === ORDER_STATUS_BID && ALLOW_SAVE_BIDS_WITH_ERRORS) {
            toggleSubmitOrderButton(!orderHasValidationErrors);
        }

        // toggle order status dropdown only when status is BID or it's not BID but the products are dirty
        if (ALLOW_SAVE_BIDS_WITH_ERRORS && (orderStatus === ORDER_STATUS_BID || productsAreDirty)) {
            if (orderStatus === ORDER_STATUS_BID) {
                toggleOrderStatusDropdown(!orderHasValidationErrors);
            } else {
                toggleOrderStatusDropdown(true);
            }

            /*if ($orderStatus && orderStatus !== ORDER_STATUS_BID && orderHasValidationErrors) {
                $orderStatus.value = ORDER_STATUS_BID;
            }*/
    }
  },
  update_folders_data: function () {
    am.$(".folder_id").each(function (_, element) {
      const $folder = am.$(element).closest(".order-folder");
      if ($folder.length === 1) {
        element.value = $folder.get(0).getAttribute("data-folder-id");
      }
    });
  },
  update_folders_subtotal: function () {
    am.$(".order-folder").each((_, el) => {
      let total = 0;
      am.$(el)
        .find(
          "#componentset .c_subtotal, #productset .p_subtotal, #supplyset .p_subtotal, .project-line-items .item_subtotal"
        )
        .each((_, el_subtotal) => {
          const qty = am.$(el_subtotal).closest("tr").find(".qty").get(0)?.value ?? "1";
          if (qty.length > 0) {
            total += cur2num(el_subtotal.textContent);
          }
        });
      am.$(el)
        .find(".folder-subtotal")
        .text(CurrencyFormatted(total.toFixed(2)));
    });
  },
  format_discount_output: function format_discount_output(
    discountAmount,
    price,
    hideAdjustment = false
  ) {
    try {
      const decimal_places = 2;
      var r = "";
      /**
       * Since .toFixed() doesn't handle the last digit correctly we add some decimals to round properly
       * eg:
       *      -3.465.toFixed(2) = -3.46 ❌
       * but
       *      -3.4650000000000001.toFixed(2) = -3.47 ✅
       *
       * This only apply for decimal numbers, not integers
       * */
      if (!Number.isInteger(cur2num(discountAmount))) {
        const fixedAmount = discountAmount + "0000000000001";
        if (
          cur2num(fixedAmount).toFixed(decimal_places) !==
          cur2num(discountAmount).toFixed(decimal_places)
        ) {
          discountAmount = fixedAmount;
        }
      }
      if (hideAdjustment) r = CurrencyFormatted(price);
      else if (discountAmount > 0)
        r =
          CurrencyFormatted(price) +
          "&nbsp; (" +
          CurrencyFormatted(
            Math.abs(cur2num(discountAmount)).toFixed(decimal_places)
          ) +
          "&nbsp;more)";
      else
        r =
          CurrencyFormatted(price) +
          "&nbsp; (" +
          CurrencyFormatted(
            Math.abs(cur2num(discountAmount)).toFixed(decimal_places)
          ) +
          "&nbsp;off)";
      return r;
    } catch (err) {
      return "-";
    }
  },
  calculate_component_totals: function calculate_component_totals() {
    var components = $("products_section").select(".product.stale.component");
    components.each(function (el) {
      var qty = parseFloat(el.down(".qty").value);
      var price = el.down(".price").innerHTML;
      if (qty > 0 && price != "-") {
        el.down(".c_subtotal")
          .update(CurrencyFormatted((qty * cur2num(price)).toFixed(2)))
          .setAttribute("data-raw-subtotal", qty * cur2num(price));
      }
    });
  },
  getSubtotalsSelector: function () {
        return document.querySelectorAll('#componentset .c_subtotal, #productset .p_subtotal, #supplyset .p_subtotal, .rproducts_total, #cart_product > .product:not(.component) .p_subtotal, #cart_product .c_subtotal, #itemizedothercost .grand_total');
    },
    /** @var {HTMLTableElement} $modalTable */
    getProductData: function () {
        const $subtotals = document.querySelectorAll(".product .p_subtotal");
        const $modalTable = document.querySelector('#taxableProductsDetail table');

        if (!$modalTable) {
            console.info('No modal table found');
            return;
        }

        let rows = '';
        $subtotals.forEach($subtotalElement => {
            const $product = $subtotalElement.closest('.product');
            const $component = $subtotalElement.closest(".product.component");
            const isComponent = $component !== null;
            const componentQty = isComponent ? ($component?.querySelector('.qty')?.value || 1) : 1;
            const isTaxable = $product?.querySelector('.is_taxable')?.value === 'true';

            const amount = cur2num($subtotalElement.innerHTML);
            const orderProductId = $product?.querySelector('.op_id')?.value;
            const productId = $product?.querySelector('.product_id')?.value;
            let productName = $subtotalElement.dataset.productName;

            if (isComponent) {
                const componentName = $component?.querySelector(".component_name")?.textContent ?? "";
                productName = componentName + " / " + productName;
            }

            rows += `
                <tr>
                    <td>${productId}</td>
                    <td>${orderProductId}</td>
                    <td class="text-start">${productName}</td>
                    <td class="text-center">${isTaxable ? '✅' : '❌'}</td>
                    <td>${(isComponent ? (componentQty + " * " + CurrencyFormatted(amount) + " = ") : "") + CurrencyFormatted(amount * componentQty)}</td>
                </tr>
            `;
        });
        $modalTable.querySelector('tbody').innerHTML = rows;
        const {taxable, nonTaxable, subtotal} = this.getOrderSubtotals();
        $modalTable.querySelector('tfoot [data-taxable]').textContent = CurrencyFormatted(taxable);
        $modalTable.querySelector('tfoot [data-non-taxable]').textContent = CurrencyFormatted(nonTaxable);
        $modalTable.querySelector('tfoot [data-subtotal]').textContent = CurrencyFormatted(subtotal);
    },
    getOrderSubtotals: function () {
        const subtotals = {subtotal: 0, taxable: 0, nonTaxable: 0};
        const $jobs = document.getElementById("jobs");
        const $productsSection = document.getElementById("products_section");

        if ($jobs && $productsSection) {
            const $subtotals = document.querySelectorAll(".product .p_subtotal");
            $subtotals.forEach($subtotalElement => {
                const $component = $subtotalElement.closest(".product.component");
                const isComponent = $component !== null;
                const isSupply = $subtotalElement.closest(".product.supply") !== null;
                const isTaxable = $subtotalElement.closest(".product")?.querySelector(".is_taxable")?.value === "true";
                let amount = cur2num($subtotalElement.innerHTML);

                if (isComponent) {
                    const componentQty = Number($component.querySelector(".qty")?.value ?? 1);
                    amount = amount * componentQty;
                }

                // all supplies are taxable and their HTML element doesn't have the `is_taxable` attribute.
                if (isTaxable || isSupply) {
                    subtotals.taxable += amount;
                } else {
                    subtotals.nonTaxable += amount;
                }
            });

          const $projectItems = document.querySelectorAll(".project-line-items tbody tr");
          $projectItems.forEach($tr => {
            const isTaxable = !$tr.querySelector("input[type='checkbox'].is_taxable")?.checked;
            // DEV-12445: read the RAW line amount (qty × price) rather than the .item_subtotal
            // text, because that text now shows the discounted value on project orders. Keeping
            // this base raw ensures the discount is applied exactly once (in calculate_tax and
            // the display) and never leaks into the taxable base or the save payload.
            const $qty = $tr.querySelector(".qty");
            const $price = $tr.querySelector(".price");
            let amount = ($qty && $price)
                ? this.getProjectLineAmounts($tr).net
                : cur2num($tr.querySelector(".item_subtotal")?.textContent ?? "0");

            if (isTaxable) {
              subtotals.taxable += amount;
            } else {
              subtotals.nonTaxable += amount;
            }
          });
        }

        subtotals.subtotal = subtotals.taxable + subtotals.nonTaxable;

        return subtotals;
    },
    getTaxableSubtotal: function () {
        return this.getOrderSubtotals().taxable;
    },
    // DEV-12445: project orders apply the order discount as a flat % on the subtotal
    // (line prices are typed in, not repriced by the pricing legs like catalog orders),
    // so the live preview has to fold the discount into the subtotal/tax/total the same
    // way the server does on save. Returns the multiplier (1 - disc/100), or 1 when N/A.
    // getOrderSubtotals() itself stays raw, so the save payload and folder/line rollups
    // are untouched -- the discount is applied only in the display + tax computations.
    getProjectDiscountPercent: function () {
        if (!this.isTypeProject()) {
            return 0;
        }
        const $el = $("disc_percent");
        if (!$el) {
            return 0;
        }
        const raw = ($el.value !== undefined && $el.value !== null && $el.value !== "")
            ? $el.value : ($el.innerHTML || "");
        const disc = cur2num(raw);
        if (!(disc > 0)) {
            return 0;
        }
        return Math.min(disc, 100);
    },
    roundCurrency: function (value) {
        const n = Number(value);
        if (!isFinite(n)) {
            return 0;
        }
        const scaled = Number((n * 100).toPrecision(15));
        return (scaled < 0 ? -Math.round(-scaled) : Math.round(scaled)) / 100;
    },
    getProjectLineAmounts: function ($tr) {
        const qty = cur2num($tr.querySelector(".qty")?.value ?? "0");
        const price = this.roundCurrency(cur2num($tr.querySelector(".price")?.value ?? "0"));
        const percent = this.getProjectDiscountPercent();
        const discount = percent > 0 ? Math.max(this.roundCurrency(price * percent / 100), 0) : 0;
        const net = Math.max(price - discount, 0);

        return {
            qty: qty,
            price: price,
            discount: discount,
            net: this.roundCurrency(net * qty),
            off: this.roundCurrency(discount * qty),
        };
    },
    // DEV-12445: reflect the order discount on each project line's subtotal display and, via
    // update_folders_subtotal(), on the Room/folder subtotal. Recomputes each line from its raw
    // qty × price and multiplies by the discount factor, so it is idempotent and never
    // double-applies. getOrderSubtotals() reads qty × price directly, so these display writes do
    // not affect the taxable base or the save payload. No-op for non-project orders.
    applyProjectLineDiscountDisplay: function () {
        if (!this.isTypeProject()) return;
        var self = this;
        var showDiscount = $('gt')?.getAttribute('data-show-order-percent-discount') !== '0';
        document.querySelectorAll(".project-line-items tbody tr").forEach(function ($tr) {
            var $sub = $tr.querySelector(".item_subtotal");
            if (!$sub || !$tr.querySelector(".qty") || !$tr.querySelector(".price")) return;
            var amounts = self.getProjectLineAmounts($tr);
            $sub.textContent = CurrencyFormatted(amounts.net.toFixed(2));

            var $off = $tr.querySelector(".item_subtotal_discount");
            if (amounts.off > 0 && showDiscount) {
                if (!$off) {
                    $off = document.createElement("span");
                    $off.classList.add("item_subtotal_discount", "small", "d-block");
                    $sub.insertAdjacentElement("afterend", $off);
                }
                $off.textContent = "(" + CurrencyFormatted(amounts.off.toFixed(2)) + " "
                    + get_language_translation("LANG_LABEL_OFF_LOWERCASE") + ")";
                $off.hidden = false;
            } else if ($off) {
                $off.textContent = "";
                $off.hidden = true;
            }
        });
        this.update_folders_subtotal();
    },
    getId: function () {
        const orderId = document.querySelector("[data-order-id]")?.dataset.orderId;
        if (orderId) {
            return Number(orderId);
        }
        return null;
    },
    isNew: function() {
        return this.getId() === null;
    },
    ensureDefaultOtherCostRow: function () {
        document.querySelectorAll(".order-folder").forEach(($folder) => {
            const folderId = $folder.dataset.folderId;
            if (!folderId) return;
            const $tbody = $folder.querySelector(".project-line-items table tbody");
            if ($tbody && !$tbody.querySelector("tr")) {
                addOtherCostRow(folderId, null, true);
            }
        });
    },
    getOtherCostsData: async function () {
        if (this.isNew()) {
            if (!document.querySelector(".order-folder")) {
                console.warn("No default folder found");
                return;
            }
            this.ensureDefaultOtherCostRow();
            return;
        }
        const orderId = this.getId();
        await fetch(`/ajax/export_classes/list/`).then(r => r.json()).then(d => {
      window.projectLineItemsExportClasses = Array.isArray(d) ? d : [];
    });
    await fetch(`/ajax/orders/other_costs/${orderId}/`).then(r => r.json()).then(data => {
            if (Array.isArray(data)) {
                data.forEach(item => {
                    addOtherCostRow(item.folder_id, {
                        id: item.id,
                        description: item.name,
                        quantity: item.quantity,
                        price: item.price,
                        isTaxable: item.is_taxable,
                        folderId: item.folder_id,
            exportClassId: item.export_class_id,
                    });
                });
            }
            this.ensureDefaultOtherCostRow();
            this.update_folders_subtotal();
            this.calculate_subtotal();
        });
    },
    calculate_subtotal: function calculate_subtotal() {
        var old_sum = this.get_subtotal_price();
        var product_sum = 0;
        var reg_product_sum = 0; // REGULAR non-discount prices



        if ($('jobs')) {
            // DEV-12445: show the order subtotal with the project discount applied.
            product_sum = this.getOrderSubtotals().subtotal;
        } else {
            $$('.total_price').each(function (el) {
                product_sum += el.value;
            });
        }

        if (this.subtotal_valid || (!$('jobs') && !$('allocation_form') && !$('production_form'))) {
            $('products_total')?.update(CurrencyFormatted(product_sum.toFixed(2)));

            // DEV-12445: fold the discount into the line + room subtotal displays (project only;
            // no-op otherwise). It also calls update_folders_subtotal(), so the room totals
            // reflect the discounted line values.
            this.applyProjectLineDiscountDisplay();
            this.update_folders_subtotal();
            this.update_folders_data();
            this.show_loading_button(false);

            return;
        }

//      if ($('disc_percent')) {
//          //product_sum = product_sum - product_sum * ($F('disc_percent') / 100);
//          product_sum = reg_product_sum - reg_product_sum * ($F('disc_percent') / 100);
//      }

        if ($('products_total') && (product_sum != old_sum || product_sum == 0)) {
            $('products_total').update(CurrencyFormatted(product_sum.toFixed(2)));
            $('products_total').setAttribute('data-subtotal', product_sum);
            this.invalidate('tax').invalidate('tax_rate').invalidate('shipping');
            //if($('order_cart'))
            //  $('order_cart').down('div.total').down('span').update($('products_total').innerHTML);
        }
        if ($('cart_info')) {
            var cart_sum = 0;
            $('cart_content').select('#componentset .c_subtotal, #productset .p_subtotal, #supplyset .p_subtotal, .rproducts_total').collect(function (a) {
                cart_sum += cur2num(a.innerHTML);
            });

            $('cart_info').down('.total').update(CurrencyFormatted(cart_sum.toFixed(2)));
            var qty = 0;
            $('componentset').select('.component').each(function (comp) {
                var nums = comp.select('.qty');
                var factor = parseInt(nums.shift().value) | 0;
                nums.each(function (element) {
                    qty += (parseInt(element.value) | 0) * factor;
                });
            });
            $('products_section').select('#productset .qty, #supplyset .qty').each(function (element) {
                qty += parseInt(element.value) | 0;
            });
            $('cart_info').down('.qty').down('span').update(qty + ' item' + (qty != 1 ? 's' : ''));
        }
        // DEV-12445: the subtotal_valid early-return above is the ONLY place the discount was folded
        // into the line/room subtotal displays. When subtotal_valid is false (e.g. a fresh single-line
        // project order on load, or a discount change that settles before a valid pass) that block is
        // skipped, so the lines/rooms render at full price even though the order totals are discounted.
        // Apply it here too so the discounted line/room subtotals show regardless of which path runs
        // (idempotent; no-op when there is no discount / not a project).
        this.applyProjectLineDiscountDisplay();
        this.update_folders_subtotal();
        this.update_folders_data();
    },
    calculate_quote_data: function calculate_quote_data() {
        if (!$('itemized_order') || $F('itemized_order') != 1)
        {
            return true;
        }
        var old_sum = this.get_quote_price();
        var quote_sum = 0;
        $('jobs').select('.subtotal').collect(function (a) {
            quote_sum += cur2num(a.innerHTML);
        });
        $('grand_total').update(CurrencyFormatted(quote_sum.toFixed(2)));
        if (quote_sum != old_sum) this.invalidate('tax').invalidate('tax_rate');
    },
    calculate_margin: function calculate_margin() {
        if (!$('itemized_order') || $F('itemized_order') != 1)
        {
            return true;
        }
        var trio = [$('gt_markup'), $('gt_profit'), $('pre_tax_price'), $('gt_precise_markup')];
        var product_sum = this.get_subtotal_price();
        var quote_sum = this.get_quote_price();

        var active_box = -1;
        trio.each(function (a, i) {
            if (i < 3 && !a.hasClassName('gray')){
                active_box = i;
            }
        });
        switch (active_box) {
            case -1:
                // declare gt_profit the one to be left alone
                trio[0].removeClassName('gray');
                trio[2].value = number_format(quote_sum + product_sum + cur2num($F(trio[1]), 2), 2);
                break;
            case 0:
                // leave gt_markup alone
                var new_markup = $F(trio[0]);
                trio[3].value = new_markup;
                trio[1].value = number_format(quote_sum * new_markup / 100, 2);
                trio[2].value = number_format(quote_sum + product_sum + cur2num($F(trio[1]), 2), 2);
                break;
            case 1:
                // leave gt_profit alone
                var profit = cur2num($F(trio[1]));
                trio[0].value = quote_sum ? number_format(profit / quote_sum * 100, 1) : '-';
                trio[3].value = quote_sum ? number_format(profit / quote_sum * 100) : '-';
                trio[2].value = number_format(profit + product_sum + quote_sum, 2);
                break;
            case 2:
                // leave pre_tax_price alone
                if ($F(trio[2]).blank()) {
                    trio[2].value = number_format(quote_sum + product_sum + cur2num($F(trio[1])), 2);
                }
                trio[1].value = (cur2num(trio[2].value) - (quote_sum + product_sum)).toFixed(2);
                trio[3].value = quote_sum ? 100 * cur2num(trio[1].value) / quote_sum : '-'; // full precision
                trio[0].value = quote_sum ? Math.round(1e3 * cur2num(trio[1].value) / quote_sum) / 10 : '-'; // up to 2 digits after the decimal
                break;
        }
        //return cur2num(number_format((quote_sum + cur2num($F(trio[1])) + product_sum), 2));
    },
    calculate_shipping: function calculate_shipping() {
        var _this3 = this;

        return new Promise(function (resolve, reject) {
            var is_simple_form = !(!($('allocation_form') || $('production_form')));
            if (_this3.shipping_valid || (!$('jobs') && !is_simple_form)) {
                return resolve(true);
            }
            var is_itemized_order = $('itemized_order');
            var is_remake = $('is_remake');
            if ($('shipping_override')) {
                _this3.invalidate('tax').invalidate('tax_rate').invalidate('total');
                return resolve(true);
            }
            if (!$('gt_shipping') && !$('shipping') && !is_itemized_order && !is_remake) {
                clear_order_form_tax_calc();
                return reject(false);
            }
            var instance;
            var instances = [];
            var params = {},
                weight = {},
                has_shipping = false;
            //var shipping_total = 0;
            var has_will_call = false;
            var has_non_will_call = false;
            params['company_id'] = $('company_id') ? $('company_id').value : 0;
            params['b2b_dropship'] = $('b2b_dropship').value;
            params['shipping_methods'] = {};
            $$('.shipping_method').each(function (el) {
                // the select's direct parent is the am-field shell since DEV-12385; the instance
                // name lives on the .shipping_method_set wrapper, so climb to it explicitly
                instance = el.up('.shipping_method_set').getAttribute('data-instance');
                //if(instances.indexOf(instance) == -1)
                //  instances.push(instance);
                weight[instance] = 0;
                params['shipping_methods'][instance] = {};
                params['shipping_methods'][instance]['method_id'] = el.value;
                params['shipping_methods'][instance]['class'] = el[el.selectedIndex].getAttribute('data-class');
                // !!!! This is a bandaid for when "will call" has been selected, but shipping_same_as_billing is not selected and no shipping info has been entered.
                // !!!! Fine for non-B2B, but a more advanced solution may be required for B2B
                if (el.value == 0)
                    has_will_call = true;
                else
                    has_non_will_call = true;
            });
            if ($('shipping_same_as_billing').checked || has_will_call) {
                params['address1'] = $F('billing_address1');
                params['address2'] = $F('billing_address2');
                params['address3'] = $F('billing_address3');
                params['city'] = $F('billing_city');
                params['state'] = $F('billing_state');
                params['zip'] = $F('billing_zip');
                params['country'] = $F('billing_country');
            } else {
                params['address1'] = $F('shipping_address1');
                params['address2'] = $F('shipping_address2');
                params['address3'] = $F('shipping_address3');
                params['city'] = $F('shipping_city');
                params['state'] = $F('shipping_state');
                params['zip'] = $F('shipping_zip');
                params['country'] = $F('shipping_country');
            }
            params['weight'] = {};
            params['price'] = {};
            if (!_this3.qtys || !_this3.qtys.length) {
                _this3.calculate_item_counts();
            }
            params['qty'] = _this3.qtys;
            if ($('jobs')) {
                $$('.prod_weight').each(function (el) {
                    var item_box = el.up('.product');
                    instance = item_box.getAttribute('data-rsource');
                    if (instances.indexOf(instance) == -1)
                    {
                        instances.push(instance);
                        weight[instance] = 0;
                    }
                    if (!isNaN(parseFloat(el.value)) && isFinite(el.value)) has_shipping = true;
                    var component_parent = el.up('.component');
                    if (component_parent !== undefined) var component_qty = parseInt(component_parent.down('.qty').value) || 0;
                    if (typeof component_qty === 'undefined') weight[instance] += parseFloat(el.value) || 0;else weight[instance] += (parseFloat(el.value) || 0) * component_qty;
                });
                $$('.c_subtotal').each(function(el) {
                    var instance = el.up('.product').getAttribute('data-rsource');
                    if (instance === 'LOCAL') {
                        if (!params['price'].hasOwnProperty(instance)) params['price'][instance] = 0;
                        params['price'][instance] += cur2num(el.innerHTML);
                    } else {
                        if (!params['price'].hasOwnProperty(instance)) params['price'][instance] = [];
                        params['price'][instance].push(el.getAttribute('data-rs'));
                    }
                    // Extra price data needed for non-dropshipping:  B2B final adjusted prices
                    if(!params.hasOwnProperty('b2b_price'))
                        params['b2b_price'] = {};
                    if(!params['b2b_price'].hasOwnProperty(instance))
                        params['b2b_price'][instance] = 0;
                    params['b2b_price'][instance] += cur2num(el.innerHTML);
                });
                $$('#productset .p_subtotal, #supplyset .p_subtotal').each(function (el) {
                    var instance = el.up('.product').getAttribute('data-rsource');
                    if (instance === 'LOCAL') {
                        if (!params['price'].hasOwnProperty(instance)) params['price'][instance] = 0;
                        params['price'][instance] += cur2num(el.innerHTML);
                    } else {
                        if (!params['price'].hasOwnProperty(instance))
                            params['price'][instance] = [];
                        params['price'][instance].push(el.getAttribute('data-rs'));
                        // Extra price data needed for non-dropshipping:  B2B final adjusted prices
                        if(!params.hasOwnProperty('b2b_price'))
                            params['b2b_price'] = {};
                        if(!params['b2b_price'].hasOwnProperty(instance))
                            params['b2b_price'][instance] = 0;
                        params['b2b_price'][instance] += cur2num(el.innerHTML);
                    }
                });
            } else {
                $$('.total_weight').each(function (el) {
                    instance = el.getAttribute('data-rsource');
                    if (instances.indexOf(instance) == -1)
                    {
                        instances.push(instance);
                        weight[instance] = 0;
                    }
                    if (!isNaN(parseFloat(el.value)) && isFinite(el.value)) has_shipping = true;
                    weight[instance] += parseFloat(el.value) || 0;
                });
                $$('.total_price').each(function (el) {
                    instance = el.getAttribute('data-rsource');
                    params['price'][instance] = el.value;
                });
            }
            // price is not calculated in project orders because there are no products so we set it manually
            if (_this3.isTypeProject()) {
                params['price']['LOCAL'] = _this3.getOrderSubtotals().subtotal;
                has_shipping = true;
            }
            if (!params['zip'].length || !has_shipping) {
                if(!is_remake)
                {
                    // if (!is_itemized_order)
                        $('shipping').update(get_currency_symbol() + '0.00');
                    // else
                    //  $('shipping_override').setAttribute('title', 'Default = '+get_currency_symbol() +'0.00');
                }
                return resolve(true);
            }
            params['weight'] = weight;
            if (_this3.tot_qty < 1 && !_this3.isTypeProject()) { // we don't want to end the promise when the quantity is 0 and it's not a project order
                if (!is_itemized_order) $('shipping').update(get_currency_symbol()+'0.00');else $('shipping_override').setAttribute('title', 'Default = '+get_currency_symbol() +'0.00');
                return resolve(true);
            }
            $$('div[id^=_shipping_method]').each(function (el) {
                el.remove();
            });
            for (instance in params['shipping_methods']) {
                if (!params['shipping_methods'].hasOwnProperty(instance)) {
                    clear_order_form_tax_calc();
                    return reject(false);
                }
            }

            var old_shipping = _this3.get_shipping_price();
            if (!is_remake && !$('itemized_order')) {
                if ($('shipping')) $('shipping').update(AM_TOTALS_SKELETON);
                if ($('final_price')) $('final_price').update(AM_TOTALS_SKELETON);
            }

            _this3.requester = new Ajax.Request('ajax/orders/get_shipping_price/', {
                parameters: { data: JSON.stringify(params) },
                onSuccess: function (ret) {
                    var ob = ret.responseJSON;
                    if ($('shipping')){
                        var mox = $('shipping').up('form').mox;
                    }
                    var list_shipping_errors = [];
                    $$('div[id^=_shipping_ajax_error_via_]').each(function (el) {
                        el.remove();
                    });
                    if ($('_shipping_error_2')) $('_shipping_error_2').remove();
                    if($('b2b_dropship').value == 0)
                    {
                        // Replace multiple shipping prices with a single total
                        var non_dropship_price = 0;
                        var non_dropship_error = '';
                        var show_shipping_breakdown = ($('b2b_dropship').getAttribute('data-is_admin') == 1);
                        if(show_shipping_breakdown)
                        {
                            if(!$('admin_view_non_dropship'))
                                $('shipping_method_set_LOCAL').insert('<div id="admin_view_non_dropship" class="am-alert am-alert--admin" style="color: black;" title="Extra shipping information only visible to an administrator."></div>');
                            if($('admin_view_non_dropship') && $('admin_view_non_dropship').innerHTML)
                                $('admin_view_non_dropship').innerHTML = '';
                        }
                        if(instances.indexOf('LOCAL') < 0) // This line needed because LOCAL gets ignored if there are no local products in a non-dropship order
                            instances.push('LOCAL');
                        for(var i = 0; i < instances.length; i++)
                        {
                            instance = instances[i];
                            if(ob[instance].hasOwnProperty('error'))
                            {
                                non_dropship_error += ob[instance].error + '<br/>';
                                if($('admin_view_non_dropship'))
                                    $('admin_view_non_dropship').insert('<div style="background-color: yellow; color: red;">' + instance + ' = Error: ' + ob[instance].error + '</div>');
                            }
                            else if(ob[instance].hasOwnProperty('price'))
                            {
                                non_dropship_price += Number(ob[instance].price);
                                if($('admin_view_non_dropship'))
                                    $('admin_view_non_dropship').insert('<div>' + instance + ' = $' + ob[instance].price + '</div>');
                            }
                        }
                        ob = { LOCAL: { price: non_dropship_price, error: non_dropship_error } };
                        instances = [ 'LOCAL' ];
                    }
                    // Again, no instances because there are no products.
                    if (_this3.isTypeProject()) {
                        instances = ["LOCAL"];
                    }
                    for (var i = 0; i < instances.length; i++) {
                        instance = instances[i];
                        if ($('loading_carriers_via_' + instance)) $('loading_carriers_via_' + instance).hide();
                        if (ob[instance].hasOwnProperty('error') && ob[instance].error.length) {
                            if (list_shipping_errors.indexOf(ob[instance].error) == -1) list_shipping_errors.push(ob[instance].error);
                            mox.validate(false, ['shipping_ajax_error_via_' + instance, 'shipping_error'], ob[instance].error);
                            $('shipping_method_set_' + instance).setAttribute('data-price', 0);
                        } else {
                            if ($('repeat_errors').childElements().length == 0) $('repeat_errors').hide();
                            if (!is_itemized_order && !is_remake)
                                mox.validate(true, 'shipping_ajax_error_via_' + instance);
                            // This element is sometimes a non-input
                            if (!is_itemized_order && !is_remake && $('shipping_override') && $('shipping_override').tagName.toLowerCase() === 'input') {
                                mox.validate(true, 'shipping_error');
                            } else {
                                // automatic Shipping Price
                                if(!is_simple_form)
                                    mox.validate(true, 'shipping_error');
                                $('shipping_method_set_' + instance).setAttribute('data-price', ob[instance].price);
                            }
                        }
                    }
                    if (list_shipping_errors.length) {
                        //mox.validate(false, 'shipping_error', list_shipping_errors.join("\n"));
                        if (!is_itemized_order) {
                            if ($('gt_shipping')) {
                                $('gt_shipping').value = '-';
                            } else {
                                $('shipping').update('-');
                            }
                            $('final_price').update('-');
                        } else {
                            $('shipping_override').setAttribute('title', 'Default = See error message.');
                        }
                        clear_order_form_tax_calc();
                        return reject(false);
                    } else {

                        var total_shipping = 0;
                        $$('.shipping_method_set').each(function (el) {
                            var instance = el.getAttribute('data-instance');
                            total_shipping += Number($('shipping_method_set_' + instance).getAttribute('data-price'));
                        });
                        if (!is_itemized_order || _this3.isTypeProject()) {
                            $("shipping").update(get_currency_symbol() + number_format(total_shipping, 2));
                        } else {
                            $("shipping_override").setAttribute("title", "Default = " + get_currency_symbol() + number_format(total_shipping, 2));
                        }
                        if (total_shipping != old_shipping) {
                            if (this.isShippingTaxed()) this.invalidate('tax').invalidate('tax_rate');
                        }
                        this.invalidate('total');
                        //sum_shipping();
                        this.shipping_valid = true;
                        return resolve(true);
                    }
                    if (!is_itemized_order) {
                        if ($('gt_shipping')) {
                            $('gt_shipping').value = '-';
                        } else {
                            $('shipping').update('-');
                        }
                        $('final_price').update('-');
                    }
                }.bind(_this3),
                onException: function onException(request, exception) {
                    if (console && console.log) {
                        console.log(['Ajax exception (get_shipping_price):', exception && exception.message, 'in', exception && exception.fileName, 'line #' + (exception && exception.lineNumber)].join(' '));
                    }
                    if ($('shipping')) $('shipping').update('-');
                    if ($('final_price')) $('final_price').update('-');
                    clear_order_form_tax_calc();
                    return reject(false);
                },
                onFailure: function onFailure(ret) {
                    if (!is_itemized_order) {
                        $('jobs').mox.validate(false, 'shipping_error', '<p>The following error occurred while trying to calculate shipping:</p><p class="bold" style="margin: 10px 0;">' + ret.status + ': ' + ret.statusText + '</p><p>Please try again later.</p>');
                        $('shipping').update('-');
                        $('final_price').update('-');
                    } else $('shipping_override').setAttribute('title', 'Could not calculate default shipping:  Status ' + html_safe(ret.status + ': ' + ret.statusText));
                    clear_order_form_tax_calc();
                    return reject(false);
                }
            });
        });
    },
    get_tax_rate: function get_tax_rate(initialLoad) {
        var _this4 = this;
        var isInitialLoad = (initialLoad === undefined) ? _this4._isInitialLoad : !!initialLoad;

        return new Promise(function (resolve, reject) {
            setTimeout(() => {
            if (_this4.tax_rate_valid || isInitialLoad || (!$('jobs') && !$('allocation_form') && !$('production_form')))
            {
                return resolve(true);
            }
            var city;
            var zip;
            var state;
            var country;
            var method_id = null;
            var address = null;
            var subtotal = null;
            var shipping = null;
            if (($('gt_tax_line')?.visible() && $('gt_tax_rate_override')) || ($('gt_gst_line')?.visible() && $('gst_rate_override'))) {
                _this4.tax_rate_valid = true;
                return resolve(true);
            }
            am.$('.taxdetail_help').fadeOut().hide();
            // Presently all orders ship to the same location, so only one destination needs to be checked for tax rates.
            // If items ever are shipped to multiple Tax regions for B2B (including will-call), multiple tax rates may need crunching, but then at that point we'd need a different order form / checkout process.
            var method_is_act_as_will_call = false;
            $$('.shipping_method').each(function (method_set) {
                let instance_name = method_set.getAttribute('data-instance_name');
                var temp_method_id = $F(method_set);
                if(instance_name === 'LOCAL') // If there is a local method and it is not "Will Call", we need to know what method it is...
                {
                    if(method_id === null || temp_method_id > 0) {
                        method_id = temp_method_id;
                        var opt = method_set.options[method_set.selectedIndex];
                        method_is_act_as_will_call = opt && opt.getAttribute('data-act-as-will-call') === '1';
                    }
                }
                else if(method_id < 1) // ...else if there is no local method, we need to simply indicate *whether* there is a B2B shipment.
                    method_id = 1;
            });
            if (method_id !== null) {
                // shipping methods aren't present on remake request form
                if (method_id == '0' || method_is_act_as_will_call || $('shipping_same_as_billing').checked) {
                    city = $F('billing_city');
                    zip = $F('billing_zip');
                    state = $F('billing_state');
                    country = $F('billing_country');
                    address = $F("billing_address1");
                } else {
                    city = $F('shipping_city');
                    zip = $F('shipping_zip');
                    state = $F('shipping_state');
                    country = $F('shipping_country');
                    address = $F("shipping_address1");
                }
                subtotal = _this4.getTaxableSubtotal();
                shipping = _this4.get_shipping_price();
            }
            if (state && zip) {
                let params = {
                    "city": city,
                    "state": state,
                    "zip": zip,
                    "country": country,
                    "method_id": method_id,
                    b2b_dropship: _this4.isB2bDropShip() && _this4.getB2bItemCount() > 0,
                    address: address,
                    subtotal: subtotal,
                    shipping: shipping,
                };
                if ($('company_id')) params.company_id = $F('company_id');

                if (!$('is_remake')) {
                    if ($('gt_taxes')) $('gt_taxes').update(AM_TOTALS_SKELETON);
                    if ($('gt_gst_taxes')) $('gt_gst_taxes').update(AM_TOTALS_SKELETON);
                    if ($('gt_pst_taxes')) $('gt_pst_taxes').update(AM_TOTALS_SKELETON);
                    if ($('final_price')) $('final_price').update(AM_TOTALS_SKELETON);
                }

                const $repeat_errors = document.querySelector('#repeat_errors');

                _this4.requester = new Ajax.Request('ajax/orders/get_tax_rate/', {
                    parameters: params,
                    onSuccess: function (ret) {
                        var ob = ret.responseJSON;
                        const taxJarErrorId = 'get_tax_rate';

                        if (ob.sales_tax_presence_missing) {
                            document.getElementById(taxJarErrorId)?.remove();
                            if (ob.is_employee && am.$('.sales-tax-presence-warning').length === 0 && typeof show_snackbar === 'function') {
                                show_snackbar({
                                    message: '<span>You do not have any sales tax presence set up, please go to the <a href="settings/financial/">Financial Settings page</a> and make at least one selection on the Sales Tax Presence setting.</span>',
                                    type: 'warning',
                                    autoClose: false,
                                    show_close: true,
                                    aux_class: 'sales-tax-presence-warning'
                                });
                            }
                        } else if (ob.error) {
                            if (typeof clear_snackbars === 'function') clear_snackbars('sales-tax-presence-warning');
                            console.error(ob.error, ob);
                            document.getElementById(taxJarErrorId)?.remove();
                            GUI.error_message($repeat_errors, taxJarErrorId, ob.error?.detail || get_language_translation('LANG_TAXJAR_API_ERROR_MESSAGE'));
                        } else {
                            document.getElementById(taxJarErrorId)?.remove();
                            if (typeof clear_snackbars === 'function') clear_snackbars('sales-tax-presence-warning');
                        }
                        if (ob.gst_rate && !ob.hst_rate) {
                            $('gt_tax_line')?.hide();
                            $('gt_gst_line')?.show();
                            $('gt_pst_line')?.show();
                                var ele = $('gt_gst_rate'),
                                    gst_rate = number_format(ob.gst_rate, 3);
                                if(ele)
                                {
                                    if (ele.hasAttribute('value')) {
                                        ele.setAttribute('title', 'Default = ' + gst_rate + '%');
                                    } else {
                                        ele.update(gst_rate);
                                    }
                                }
                                var ele = $('gt_pst_rate'),
                                    pst_rate = number_format(ob.pst_rate, 3);
                                if(ele)
                                {
                                    if (ele.hasAttribute('value')) {
                                        ele.setAttribute('title', 'Default = ' + pst_rate + '%');
                                    } else {
                                        ele.update(pst_rate);
                                    }
                                }
                                var ele = $('gt_tax_rate');
                                if(ele)
                                {
                                    if (ele.hasAttribute('value')) {
                                        ele.value = '';
                                    } else {
                                        ele.update();
                                    }
                                }
                        } else {
                            try {
                                $('gt_gst_line')?.hide();
                                $('gt_pst_line')?.hide();
                                $('gt_tax_line')?.show();
                                    if($('gt_tax_rate')){
                                        var ele = $('gt_tax_rate'),
                                            rate = (ob.hst_rate ? number_format(ob.hst_rate,3) : number_format(ob.rate, 3));
                                        if (ele.hasAttribute('value')) {
                                            ele.setAttribute('title', 'Default = ' + rate + '%');
                                        } else {
                                            ele.update(rate);
                                        }
                                    }
                                    if($('gt_gst_rate')){
                                        var ele = $('gt_gst_rate');
                                        if (ele && ele.hasAttribute('value')) {
                                            ele.value = '';
                                        } else {
                                            ele.update();
                                        }
                                    }
                                    if($('gt_pst_rate')){
                                        var ele = $('gt_pst_rate');
                                        if (ele && ele.hasAttribute('value')) {
                                            ele.value = '';
                                        } else {
                                            ele.update();
                                        }
                                    }

                            } catch (error) {
                                console.log(error);
                            }
                        }
                        $('tax_shipping').value = ob.tax_shipping;
                        this.tax_rate_valid = true;
                        this.invalidate('tax').invalidate('tax_rate');
                        return resolve(true);
                    }.bind(_this4),
                    onException: function onException(request, exception) {
                        if (console && console.log) {
                            console.log(['Ajax exception (get_tax_rate):', exception && exception.message, 'in', exception && exception.fileName, 'line #' + (exception && exception.lineNumber)].join(' '));
                        }
                        return reject(false);
                    },
                    onFailure: function onFailure(ret) {
                        return reject(false);
                    }
                });
            } else {
                var ele = $('gt_tax_rate');
                if (ele?.value) {
                    ele.value = '0.000';
                } else {
                    ele?.update('0.000');
                }

                if ($('tax_shipping')) // not preset on remake request form
                    $('tax_shipping').value = 0;
                return resolve(true);
            }
            }, 1000);
        });
    },
    isB2bDropShip: function () {
        return document.querySelector('#b2b_dropship')?.value == 1;
    },
    getB2bItemCount: function () {
        let b2bCount = 0;
        const items = {};
        document.querySelectorAll(".product").forEach(function ($prod) {
            const instance = $prod.dataset.rsource;
            if (instance in items) {
                items[instance]++;
            } else {
                items[instance] = 1;
            }
            if (instance !== "LOCAL") {
                b2bCount++;
            }
        });
        if (b2bCount > 0) {
            console.info("b2bItems:", items);
        }
        return b2bCount;
    },
    is_shipping_tax_available: function () {
        return $('tax_on_shipping') != null;
    },
    isShippingTaxed: function () {
        return [true, 'true', 1, '1'].includes(document.getElementById('tax_shipping')?.value);
    },
    update_shipping_tax: function (value) {
        if (this.is_shipping_tax_available()) {
            $('tax_on_shipping').update(CurrencyFormatted(value));
        }
    },
    getTaxableQuoteSubtotal: function () {
        if (!$("grand_total")) return 0;
        var grandTotal = this.get_quote_price();
        var otherCostsTotal = 0;
        if ($("costs_total")) {
            otherCostsTotal = cur2num($("costs_total").innerHTML);
        }
        var taxableOtherCostsTotal = 0;
        if ($("costs")) {
            $("costs")
                .select("tbody tr")
                .each(function (tr) {
                    var priceInput = tr.down(".costs.currency");
                    if (!priceInput) {
                        return;
                    }
                    var price = cur2num(priceInput.value || priceInput.innerHTML);
                    var exemptCheckbox = tr.down(".is_taxable_cost");
                    var isExempt = exemptCheckbox && exemptCheckbox.checked;
                    if (!isExempt) {
                        taxableOtherCostsTotal += price;
                    }
                });
        }
        var nonOtherQuoteTotal = grandTotal - otherCostsTotal;
        return nonOtherQuoteTotal + taxableOtherCostsTotal;
    },
    calculate_tax: function calculate_tax() {
        if (this.tax_valid || !$('jobs'))
        {
            return true;
        }
        // DEV-12445: tax the discounted taxable base for projects (line prices are typed,
        // so the order discount isn't already baked into them like catalog line items).
        var product_sum = this.getTaxableSubtotal();
        var taxable_quote_sum = this.getTaxableQuoteSubtotal();
        var total_quote_sum = this.get_quote_price();
        var profit = this.get_profit_price();
        var taxable_profit = profit;

        if (profit > 0 && total_quote_sum > 0) {
            var ratio = taxable_quote_sum / total_quote_sum;
            if (ratio < 0) ratio = 0;
            if (ratio > 1) ratio = 1;
            taxable_profit = profit * ratio;
        }

        var cost_total = product_sum + taxable_quote_sum + taxable_profit;
        var shipping_cost = this.get_shipping_price();
        const shipping_tax_available = this.is_shipping_tax_available();
        if ($('gt_tax_rate_override') && $('gt_tax_line').visible()) {
            var tax_rate = parseFloat($F('gt_tax_rate_override'));
            if (this.isShippingTaxed()) {
                $('gt_taxes').update(CurrencyFormatted((Math.round(Math.floor(tax_rate * (cost_total + (shipping_tax_available ? 0 : shipping_cost)) * 10) / 10) / 100).toFixed(2)));
                this.update_shipping_tax((shipping_cost * tax_rate / 100).toFixed(2));
            } else {
                $('gt_taxes').update(CurrencyFormatted((Math.round(Math.floor(tax_rate * cost_total * 10) / 10) / 100).toFixed(2)));
                this.update_shipping_tax('0');
            }
        }
        else if ($('gt_tax_rate') && $('gt_tax_line').visible()) {
            var tax_rate = parseFloat($('gt_tax_rate').innerHTML);
            if (this.isShippingTaxed()) {
                $('gt_taxes').update(CurrencyFormatted((Math.round(Math.floor(tax_rate * (cost_total + (shipping_tax_available ? 0 : shipping_cost)) * 10) / 10) / 100).toFixed(2)));
                this.update_shipping_tax((shipping_cost * tax_rate / 100).toFixed(2));
            } else {
                $('gt_taxes').update(CurrencyFormatted((Math.round(Math.floor(tax_rate * cost_total * 10) / 10) / 100).toFixed(2)));
                this.update_shipping_tax('0');
            }
        }
        else {
            let tax_rate_on_shipping = 0; // we want to calculate the tax using gst + pst rates
            if ($('gt_gst_line').visible()) {
                const tax_rate = ($('gt_gst_rate_override') ? parseFloat($F('gt_gst_rate_override')) : parseFloat($('gt_gst_rate').innerHTML));
                tax_rate_on_shipping += tax_rate;
                if (this.isShippingTaxed()) {
                    let gst_amount = parseFloat((cost_total * tax_rate / 100).toFixed(2));
                    gst_amount += parseFloat((tax_rate * (shipping_tax_available ? 0 : shipping_cost) / 100).toFixed(2));

                    $('gt_gst_taxes').update(CurrencyFormatted(gst_amount.toFixed(2)));
                    this.update_shipping_tax((shipping_cost * tax_rate_on_shipping / 100).toFixed(2));
                } else {
                    $('gt_gst_taxes').update(CurrencyFormatted((Math.round(Math.floor(tax_rate * cost_total * 10) / 10) / 100).toFixed(2)));
                    this.update_shipping_tax('0');
                }
            }

            if ($('gt_pst_line').visible()) {
                const tax_rate = ($('gt_pst_rate_override') ? parseFloat($F('gt_pst_rate_override')) : parseFloat($('gt_pst_rate').innerHTML));
                tax_rate_on_shipping += tax_rate;
                if (this.isShippingTaxed()) {
                    let pst_amount = parseFloat((cost_total * tax_rate / 100).toFixed(2));
                    pst_amount += parseFloat((tax_rate * (shipping_tax_available ? 0 : shipping_cost) / 100).toFixed(2));

                    $('gt_pst_taxes').update(CurrencyFormatted(pst_amount.toFixed(2)));
                    this.update_shipping_tax((shipping_cost * tax_rate_on_shipping / 100).toFixed(2));
                } else {
                    $('gt_pst_taxes').update(CurrencyFormatted((Math.round(Math.floor(tax_rate * cost_total * 10) / 10) / 100).toFixed(2)));
                    this.update_shipping_tax('0');
                }
            }
        }
        this.invalidate('total');
        this.restoreTaxTooltips();
        this.tax_valid = true;
    },
    restoreTaxTooltips: function restoreTaxTooltips() {
        var hints = this._taxHints || {};
        ['gt_taxes', 'gt_gst_taxes', 'gt_pst_taxes'].forEach(function(id) {
            var el = document.getElementById(id);
            if (el && hints[id] && !el.querySelector('.hint--top')) {
                var content = el.innerHTML;

                var span = document.createElement('span');
                span.className = 'hint--top hint--no-animate hint--rounded';
                span.setAttribute('data-hint', hints[id]);
                span.innerHTML = content;
                el.innerHTML = '';
                el.appendChild(span);
            }
        });
    },
    calculate_total: function calculate_total() {
        if (this.total_valid || (!$('jobs') && !('production_form')))
        {
            return true;
        }
        const shipping_tax = this.get_shipping_tax_price();
        var total = this.get_subtotal_price() + this.get_shipping_price() + this.get_quote_price() + this.get_profit_price() + this.get_tax_price() + shipping_tax;
        try{
            $('final_price').update(CurrencyFormatted((total).toFixed(2)));
        }
        catch(err){}
        if ($('limit_notice')) {
            var remaining = $('limit_notice').getAttribute('data-remaining-limit');
            if (remaining.length > 0 && remaining - total < 0)
                $('limit_notice').show();
            else
                $('limit_notice').hide();
        }
        this.total_valid = true;
    },
    get_shipping_price: function get_shipping_price() {
        if($('is_remake'))
            return 0;
        var shipping = '';
        var shippingoverride = '';
        if($('shipping') && $('shipping').innerHTML)
            shipping = $('shipping').innerHTML;
        if($('shipping_override') && $('shipping_override').innerHTML)
            shippingoverride = $('shipping_override').innerHTML.replace(get_currency_symbol(), '');

        return $('shipping_override') ? cur2num($('shipping_override').tagName.toLowerCase() === 'input' ? $F('shipping_override') : shippingoverride) : cur2num(shipping);
    },
    get_subtotal_price: function get_subtotal_price() {
        if($('products_total') && $('products_total').innerHTML)
            return cur2num($('products_total').innerHTML.replace(get_currency_symbol(), ''));
        else
            return null;
    },
    get_quote_price: function get_quote_price() {
        if (!$('grand_total')) return 0;
        return cur2num($('grand_total').innerHTML.replace(get_currency_symbol(), ''));
    },
    get_profit_price: function get_profit_price() {
        if (!$('gt_profit')) return 0;
        return cur2num($F('gt_profit'));
    },
    get_tax_price: function get_tax_price() {
        var tax_price = 0;
        if($('gt_taxes') && $('gt_tax_line') && $('gt_tax_line').visible())
            tax_price = $('gt_taxes') && $('gt_tax_line').visible() ? cur2num($('gt_taxes').textContent) : 0;
        if($('gt_gst_taxes') && $('gt_gst_line') && $('gt_gst_line').visible())
            tax_price += $('gt_gst_taxes') && $('gt_gst_line').visible() ? cur2num($('gt_gst_taxes').textContent) : 0;
        if($('gt_pst_taxes') && $('gt_pst_line') && $('gt_pst_line').visible())
            tax_price += $('gt_pst_taxes') && $('gt_pst_line').visible() ? cur2num($('gt_pst_taxes').textContent) : 0;
        return tax_price;
    },
    get_shipping_tax_price: function () {
        const tag = $('tax_on_shipping');
        if (!tag) {
            return 0;
        }
        return cur2num(tag.innerText);
    },
    clear_grouped_validation_messages: function (container) {
        const productContainer = container.closest('.product');
        let groupedMessageContainer = productContainer.querySelector('.grouped_messages');
        if (groupedMessageContainer) {
            groupedMessageContainer.innerHTML = '';
            if (!window.grouped_validation_messages) {
                window.grouped_validation_messages = {};
            }
            if (window.grouped_validation_messages[productContainer.id]) {
                window.grouped_validation_messages[productContainer.id] = [];
            }
        }
    },
    show_validation_message_once: function (container, msg) {
        if (!window.grouped_validation_messages) {
            window.grouped_validation_messages = {};
        }

        //for grouped
        const productContainer = container.closest('.product');
        let groupedMessageContainer = productContainer.querySelector('.grouped_messages');

        if (!groupedMessageContainer) {
            const table = productContainer.querySelector('.item_table');
            groupedMessageContainer = document.createElement('div');
            groupedMessageContainer.classList.add('grouped_messages');
            groupedMessageContainer.style.clear = 'both';// add this because our current css is odd
            productContainer.insertBefore(groupedMessageContainer, table);
        }

        if (!window.grouped_validation_messages[productContainer.id]) {
            window.grouped_validation_messages[productContainer.id] = [];
            groupedMessageContainer.innerHTML = '';
        }

        const messageKey = msg.type + '_' + msg.message;
        if (!window.grouped_validation_messages[productContainer.id].includes(messageKey)) {
            const messageElement = document.createElement('div');

            messageElement.classList.add(msg.type);
            if ('message_type' in msg && msg.message_type === 'image_url') {
                messageElement.innerHTML = `<img src="${msg.message}" class="w-100 h-auto" />`;
            } else if ('message_type' in msg && msg.message_type === 'plain_text') {
                messageElement.innerHTML = msg.message;
            } else {
                messageElement.innerHTML = msg.message;
            }

            groupedMessageContainer.append(messageElement);

            window.grouped_validation_messages[productContainer.id].push(messageKey);
        }
    },
    show_validation_message: function (container, msg) {
        const messageElement = document.createElement('div');

        messageElement.classList.add(msg.type);
        if ('message_type' in msg && msg.message_type === 'image_url') {
            messageElement.innerHTML = `<img src="${msg.message}" class="w-100 h-auto" />`;
        } else if ('message_type' in msg && msg.message_type === 'plain_text') {
            messageElement.innerHTML = msg.message;
        } else {
            messageElement.innerHTML = msg.message;
        }

        container.append(messageElement);
    },
    /**
     * @param {Array|Object} data
     * @param {HTMLElement} container
     */
    handleTaxExemptLabel: function (data, container) {
        const isTaxable = Array.isArray(data) ? data.every(item => ('is_taxable' in item && item.is_taxable)) : ('is_taxable' in data && data.is_taxable);
        const $productSelector = container.closest('.product');
        const $taxExemptLabel = $productSelector?.querySelector('.label-product-tax-exempt');
        const $isTaxableField = $productSelector?.querySelector('.is_taxable');

        if ($taxExemptLabel) {
            $taxExemptLabel.classList.toggle('d-none', isTaxable);
        }

        if ($isTaxableField) {
            $isTaxableField.value = isTaxable ? 'true' : 'false';
        }
    },
    getCompanyId: function () {
        const id = document.querySelector("#company_id")?.value;
        return isNaN(Number(id)) ? null : Number(id);
    },
    getCompanyTags: function () {
        const tags = document.querySelector("#company_tags")?.value;
        if (!tags) {
            return [];
        }
        try {
            return JSON.parse(tags);
        } catch (e) {
            console.error("Error parsing company tags", e, tags);
            return [];
        }
    },
    setCompanyTags: function (tags) {
        const $tags = document.querySelector("#company_tags");
        if (!$tags) {
            console.info("Company tags selector not found, skipping setCompanyTags", tags);
            return;
        }
        $tags.value = JSON.stringify(tags);
    },
    getOrderStatus: function () {
        /** @type HTMLSelectElement */
        const statusElement = document.querySelector('#status');

        if (statusElement) {
            const orderStatus = (statusElement.value || "").trim();
            if (orderStatus.length === 0) {
                console.warn(`Order status is empty, fallback to ${ORDER_STATUS_BID}`);
                return ORDER_STATUS_BID;
            }
            return orderStatus;
        }

        const statusDropdown2 = document.querySelector('#jorder_status');

        return statusDropdown2?.value || null;
    },
    getOrderType: function () {
        /** @type HTMLInputElement */
        const $typeElement = document.querySelector("#order_type");

        if ($typeElement) {
            return $typeElement.value;
        }

        return "order";
    },
    isTypeProject: function () {
        return this.getOrderType() === "project";
    },
    orderStatusIsDirty: function () {
        /** @type HTMLSelectElement */
        const statusDropdown = document.querySelector('#status');
        const statusDropdown2 = document.querySelector('#jorder_status');

        if (!statusDropdown || !statusDropdown2) {
            console.info('#status or #jorder_status is missing', statusDropdown, statusDropdown2);
            return false;
        }

        return statusDropdown?.value !== statusDropdown2?.value;
    },
    /**@param {HTMLElement} container */
    productIsDirty: function (container) {
        return container.closest('.product')?.querySelector('.is_dirty')?.value === 'true';
    },
    /**@param {HTMLElement} container */
    productIsNew: function (container) {
        return isNaN(parseInt(container.closest('.product')?.querySelector('.op_id')?.value));
    },
    /**@param {HTMLElement} container */
    productIsB2b: function (container) {
        const instance = container.closest(".product")?.dataset.rsource;
        return instance !== "LOCAL";
    },
    /**@param {HTMLElement} container */
    getInstanceCompanyB2bTags: function (container) {
        const tags = container.closest(".product")?.dataset.instanceCompanyTags;
        if (!tags) {
            return [];
        }
        try {
            return JSON.parse(tags);
        } catch (e) {
            console.error("Error parsing instange company b2b tags", e, tags);
            return [];
        }
    },
    /**
     * @param {HTMLElement} container
     * @param {Object} data
     * */
    productValidationsChanged(container, data) {
        const storedValidationsHash = container.closest('.product')?.dataset['validationsHash'] ?? null;
        const currentValidationsHash = data._validations ?? null;

        return storedValidationsHash !== null && storedValidationsHash !== currentValidationsHash;
    },
    handle_price_error: function handle_price_error(data, container) {
        var errbox = container.down('.error_container'),
            alt_box;
        var component = container.up('.collapsible');
        const statusIsBid = this.getOrderStatus() === ORDER_STATUS_BID;
        const statusIsOrdered = this.getOrderStatus() === ORDER_STATUS_ORDERED;
        const statusIsVerified = this.getOrderStatus() === ORDER_STATUS_VERIFIED;
        const productIsDirty = this.productIsDirty(container);
        const productValidationsChanged = this.productValidationsChanged(container, data);
        const ALLOW_SAVE_BIDS_WITH_ERRORS = allowToSaveBidWithValidationErrorsEnabled();
        const {is_admin} = get_user_info();
        if (is_admin) {
            console.info({
                statusIsBid,
                statusIsOrdered,
                statusIsVerified,
                productIsDirty,
                productValidationsChanged,
                ALLOW_SAVE_BIDS_WITH_ERRORS,
                dataValid: data.valid,
                messages: data.v_msg
            });
        }

        if (errbox) {
            if (component) {
                alt_box = errbox.up('.component').down('.dh').down('.error') || document.createElement('div');
            } else {
                alt_box = document.createElement('div');
            }
            if (data.valid == "0") {
                if (ALLOW_SAVE_BIDS_WITH_ERRORS) {
                    if ((productValidationsChanged && productIsDirty) || productIsDirty || statusIsBid) {
                        errbox.up('tr').addClassName('fail');
                    } else {
                        errbox.up('tr').addClassName('hidden-fail');
                    }
                } else {
                    if (statusIsBid) {
                        errbox.up('tr').addClassName('fail');
                    } else {
                        if ((productValidationsChanged && productIsDirty) || productIsDirty) {
                            errbox.up('tr').addClassName('fail');
                        } else {
                            errbox.up('tr').addClassName('hidden-fail');
                        }
                    }
                }
            } else {
                errbox.up('tr').removeClassName('fail').removeClassName('hidden-fail');
            }
            errbox.update();
            const isUngroupedProduct = container.closest('.product').querySelector('.item_table.line_items') === null;
            const _this = this;
            if (data.v_msg) {
                data.v_msg.each(function (msg) {
                    if (statusIsBid) {
                        if (!msg.once_per_group || isUngroupedProduct) {
                            _this.show_validation_message(errbox, msg);
                        } else {
                            _this.show_validation_message_once(container, msg);
                        }
                        if (component && component.down('.error') || container.down('.error')) {
                            alt_box.update('<b>There are errors in this component.</b>');
                        }
                    } else {
                        if (
                            (productValidationsChanged && productIsDirty) ||
                            productIsDirty || ((statusIsOrdered || statusIsVerified) && msg.type === 'notice')
                        ) {
                            if (!msg.once_per_group || isUngroupedProduct) {
                                _this.show_validation_message(errbox, msg);
                            } else {
                                _this.show_validation_message_once(container, msg);
                            }
                            if (component && component.down('.error') || container.down('.error')) {
                                alt_box.update('<b>There are errors in this component.</b>');
                            }
                        }
                    }
                });
                errbox.show();
                if (component && component.down('.error')) alt_box.show();else alt_box.hide();
            } else {
                // to prevent clearing grouped error messages when there are errors in previous items
                const failCount = document.querySelectorAll('.fail').length;
                const hiddenFailCount = document.querySelectorAll('.hidden-fail').length;
                if (failCount === 0 && hiddenFailCount === 0) {
                    this.clear_grouped_validation_messages(container);
                    errbox.hide();
                }
                if ('' == alt_box.innerHTML) alt_box.hide();
            }
        }
        highlight_folders_with_errors();
    },
    update_product_price: function update_product_price(data, container, rtype) {
		try{
			if($('is_remake'))
			{
				return;
			}

			var price = container.down('.price');
			var child = price.down();

			if (child) {
				switch (child.tagName) {
					case 'A':
						price = child;
                        // break; // THIS BREAKS THE PRICING STUFF
					case 'BR':
						child = false;
						break;
					case 'SPAN':
						// if is a price override
						child.down('input').value = (data.price.replace(new RegExp(',', 'g'), '') - 0).toFixed(2);
						break;
				}
			}

			if (!child) {
				if (price.down() && 'A' === price.down().tagName){
					price = price.down();
				}
                if (data.hasOwnProperty('raw_price')) {
                    price.setAttribute('data-raw-price', data.raw_price);
                }
                const hideAdj = data.isremote;
				if(data.price == '-'){
					price.update('-');
                } else if (data.hasOwnProperty('adjustments') && typeof data.adjustments === 'object') {
                    /*
                    * visible_amount: visible adjustments + order discount depending if it's visible or not
                    * */
                    if (data.adjustments.visible_amount && data.adjustments.visible_amount != 0) {
                        price.update(this.format_discount_output(data.adjustments.visible_amount + '', data.price,hideAdj));
                    } else {
                        price.update(CurrencyFormatted(data.price));
                    }
                } else if (data._adj && data._adj.amountToBeShown && data._adj.amountToBeShown !== 0) { // https://allmoxy.atlassian.net/browse/DEV-4312
                    price.update(this.format_discount_output(data._adj.amountToBeShown, data.price,hideAdj));
                }
				else if(data._adj && data._adj.total && data._adj.total && data._adj.shouldDiscountShow != 0 && CurrencyFormatted(data.price) + ((data._adj.total && !data.rs))){
					var tempAdj = data._adj.total;
					if(data._discount && data._discount.amt){
						tempAdj += data._discount.amt;
					}
                    price.update(this.format_discount_output(tempAdj, data.price,hideAdj));
				}
				else if(data._discount && data._discount.amt && CurrencyFormatted(data.price) + ((data._discount.amt && !data.rs))){
					price.update(this.format_discount_output(data._discount.amt, data.price,hideAdj));
				}
				else if(data._adj && data._adj.total &&  data._discount && data._discount.amt && data._discount.amt != 0 && data._adj.total != 0){
					price.update(this.format_discount_output(data._adj.total + data._discount.amt, data.price,hideAdj));
				}
				else if(data._discount && data._discount.amt && data._discount.amt != 0){
					price.update(this.format_discount_output(data._discount.amt, data.price,hideAdj));
				}
				else if((data._adj && data._adj.shouldDiscountShow && data._adj.shouldDiscountShow == 0) || (data._adj && data._adj == '')){
					price.update(CurrencyFormatted(data.price));
				}
                else {
					price.update(CurrencyFormatted(data.price));
				}
			} else {
                if ('SPAN' == child.tagName) {
                    // to show the input to override price
                    if (child.down('input').getAttribute('name').indexOf('price_override') == -1) {
                        price.update(CurrencyFormatted(data.price));

                        if (data.hasOwnProperty('raw_price')) {
                            price.setAttribute('data-raw-price', data.raw_price);
                        }
                    }
                }
            }

            if (rtype) {
				if (child) {
					if (child.down('input').getAttribute('name').indexOf('roverride') == -1)
                        if (data.hasOwnProperty('price')) {
                            price.up().down('input.rprice').value = data.price.replace(',', '');
                        }
				}
                else{
                    if (data.hasOwnProperty('price')) {
                        price.up().up().down('input.rprice').value = data.price.replace(',', '');
                    }
                }
			}
			if (data.subtotal) {
				container.down('.prod_weight').value = data.ship_weight;
				container.down('.p_subtotal').update(data.subtotal == '-' ? '-' : CurrencyFormatted(data.subtotal));
				if (data.rs) container.down('.p_subtotal').setAttribute('data-rs', data.rs);
			} else {
				container.down('.prod_weight').value = '-';
				container.down('.p_subtotal').update('-');
			}

            if (data.hasOwnProperty('raw_subtotal') && !isNaN(data.raw_subtotal)) {
                container.down('.p_subtotal').setAttribute('data-raw-subtotal', data.raw_subtotal);
            }
            if (data.hasOwnProperty('original_price')) {
                container.down('.p_subtotal').setAttribute('data-original-price', data.original_price);
            }
            if (data.hasOwnProperty('is_price_valid')) {
                const tr = container.down('.priceoverride');

                if (tr) {
                    if (!data.is_price_valid) {
                        tr.classList.add('broken-price-error');
                    } else {
                        tr.classList.remove('broken-price-error');
                    }
                }

                container.down('.p_subtotal').setAttribute('data-valid-price', data.is_price_valid);
            }
			if(data.hasOwnProperty('reg_price'))
				container.down('.p_subtotal').setAttribute('data-reg_subtotal', (data.reg_price * data.qty).toFixed(2));
			else if(data.subtotal && !isNaN(data.subtotal.toString().replace(/\,/g,'')))
				container.down('.p_subtotal').setAttribute('data-reg_subtotal', parseFloat(data.subtotal.toString().replace(/\,/g,'')).toFixed(2));
			else
				container.down('.p_subtotal').setAttribute('data-reg_subtotal', 0);
		}
		catch(err){
			console.log(err);
		}

    },
    update_group_subtotals: function update_group_subtotals(el, data, is_remake = false) {
        if (el.down('.gtotal')) {
            var item_count = 0;
            var group_price = 0;
            data.each(function (el) {
                if (el.valid < 3 && !isNaN(parseFloat(el.subtotal))) {
                    item_count += parseInt(el.qty);
                    if(!is_remake) {
                        group_price += parseFloat(cur2num(el.subtotal));
                    }
                }
            });

            el.down('.gitotal').update(item_count);
            el.down('.gtotal').update(CurrencyFormatted(group_price.toFixed(2)));
        }
    },
    formatNumber: (number, decimalPlaces = 2) => {
        if (typeof number !== 'number') {
            return number;
        }

        return number.toLocaleString('en-US', {
            minimumFractionDigits: decimalPlaces,
            maximumFractionDigits: decimalPlaces,
        });
    }
});
var theOrder;
